/**
 * 통합검색
 *
 * DIT 2.0 (jira - LGECOMVIO-23)
 *  - 같은 폴더 search_all.js 기반으로 작성
 *  - 같은 폴더의 search_카테고리명.js 통합본으로 보시면 됩니다.
 *  - 같은 폴더의 search_all.js 을 포함한 search_카테고리명.js 는 더이상 사용하지 않습니다.
 *
 * @since 2023.10.23
 */
 if ("scrollRestoration" in history) {
  //BTOCSITE-2216 뒤로가기로 페이지 진입했을때 강제 스크롤이동을 위한 히스토리 스크롤값 수동으로 변경
  history.scrollRestoration = "manual";
}

(function () {
  //자동완성
  var autoCompleteItemTemplate =
    '<li><a href="#{{input}}">{{#raw text}}</a><button class="keyword_select"  data-contents="{{input}}" >검색어선택</button></li>';
  //자동완성 상품리스트
  var autoCompletePrductListTemplate =
	'<li>' +
	'<a href="{{modelUrlPath}}" >' +
	'    <span class="prod-img"><img src="{{_imageUrl}}" onError="lgkorUI.addImgCateErrorEvent(this, \'{{noImageUrl}}\' );" alt="{{modelName}}"></span>' +
	'    <div class="model-info">' +
	'        <p class="model-name">{{#raw _modelName}}</p> <!-- 검색어와 일치한 단어의 srch-word 추가 -->' +
	'        <div class="prod-path">' +
	'            <span>{{superCategoryName}}</span>' +
	'            <span>{{categoryName}}</span>' +
	'        </div>' +
	'    </div>' +
	'    <span class="txt-direct">제품 바로가기</span>' +
	'</a>' +
	'</li>';

  //자동완성 브랜드리스트
  var autoCompleteBrandListTemplate =
	  '<a href="{{brandUrlPath}}">' +
	  '<span class="brand-img {{brandCss}}"><span class="blind">{{brandName}}</span></span>' +
	  '<span class="txt-direct">브랜드관 바로가기</span>' +
	  '</a>';

  //최근검색어
  var recentItemTemplate =
    '<li><span class="box"><a href="#{{text}}">{{text}}</a><button type="button" class="btn-delete" title="검색어 삭제"><span class="blind">삭제</span></button></span></li>';

  //연관검색어
  var relatedItemTemplate = '<li><a href="#{{text}}">{{text}}</a></li>';

  //인기검색어
  var popularItemTemplate =
    '<li><a href="#{{text}}"><b>{{index}}.</b>{{text}}</a></li>';

  //많이 찾은 키워드
  var topicItemTemplate =
    '<li><a href="{{#if type=="search"}}#{{/if}}{{linkUrl}}">{{text}}</a></li>';

  //추천카테고리
  var categoryItemTemplate =
    '<li><a href="{{url}}" class="rounded"><span class="text">{{#raw text}}</span></a></li>';

  //정렬 셀렉트
  //prettier-ignore
  var sortSelectTempate =
    '<select class="ui_selectbox" title="정렬">' +
    '{{#if ( !(modal && unit == "disposable") )  }}<option value="best">추천순</option>{{/if}}' + // 소모품 팝업에서 비노출 || 제품유닛> 큐레이션 있을때는 비노출
      '<option value="date">최신순</option>' +
      '<option value="pricedesc">가격 높은순</option>' +
      '<option value="priceasc">가격 낮은순</option>' +
    '</select>'

	// unit별 상단 소팅 영역
	var unitTitleTemplate =
		'<div>'+
			'<div class="sort-area left">' +
				'<p class="sort-tit">{{title}}</p>' +
			'</div>' +
			'<div class="sort-area">' +
				'<div class="sort-list">' +
					'<div class="sort-select-wrap">' +
						'{{#if unit=="product" || unit=="disposable" || unit=="subscribe"  }}' +
							sortSelectTempate +
						'{{/if}}' +
					'</div>' +
				'</div>' +
			'</div>' +
			'<div class="mob-sort-check">' +
				'{{#if multiItem.show}}'+
					'<span class="chk-wrap">'+
						'<input type="checkbox" id="multi_product_chk01" name="multi_product_chk1" {{#if multiItem.checked}}checked{{/if}}>' +
						'<label for="multi_product_chk01">다품목할인</label>' +
					'</span>'+
				'{{/if}}' +
				'{{#if tomorrow.show}}' +
					'<span class="chk-wrap tomorrow-delivery">'+
						'<input type="checkbox" id="tomorrow_chk01" name="tomorrow_chk1" {{#if tomorrow.checked}}checked{{/if}}>' +
						'<label for="tomorrow_chk01">내일배송</label>' +
					'</span>' +
				'{{/if}}' +
			'</div>'+
		'</div>';

  //BTOCSITE-32032 내일 배송 확대
   var topTomorrowTemplate =
          '<span class="chk-wrap tomorrow-delivery">' +
            '<input type="checkbox" id="tomorrow_chk02" name="tomorrow_chk2" {{#if tomorrow.checked}}checked{{/if}}>' +
            '<label for="tomorrow_chk02">내일배송</label>' +
          '</span>'  ;
   //BTOCSITE-48682 다품목할인
   var topMultiItemTemplate =
       '<span class="chk-wrap">' +
         '<input type="checkbox" id="multi_product_chk02" name="multi_product_chk2" {{#if multiItem.checked}}checked{{/if}}>' +
         '<label for="multi_product_chk02">다품목할인</label>' +
       '</span>'  ;
   var topEmployeeTemplate =
       '<span class="chk-wrap">' +
         '<input type="checkbox" id="employee_chk02" name="employee_chk2" {{#if employee.checked}}checked{{/if}}>' +
         '<label for="employee_chk02">임직원할인</label>' +
       '</span>'  ;
  //프로모션 배너
  //BTOCSITE-39101 텍스트 컬러값 입력
  //prettier-ignore
  var bannerTemplate =
    '<a href="{{linkUrl}}" class="bnr_area" style="background-image: url(\'{{_imageUrl}}\');">' +
      '<div class="bnr_txt">' +
        '<span class="txt_b" {{#if fontColor != ""}}style="color:{{fontColor}};"{{/if}}>{{title}}</span>' +
        '<span class="txt_s" {{#if fontColor != ""}}style="color:{{fontColor}};"{{/if}}>{{description}}</span>' +
      "</div>" +
    "</a>";

  //ai 연결
  //prettier-ignore
  var aiTemplate =
    '<div class="ai_head">' +
      '<div class="head_stit">제품 사용 중</div>' +
      '<div class="head_btit">이런 도움이 필요하세요?</div>' +
    '</div>' +
    '<div class="ai_body">' +
      '<div class="body_tit">{{#raw title}}</div>' +
      '<div class="body_cnt">{{#raw description}}</div>' +
    '</div>';

	// 서비스 게이트 연결
	// [BTOCSITE-47883] 아이콘 영역 추가
	// prettier-ignore
	var serviceTemplate =
		'<span class="icon"></span>' +
		'<div class="service_title">{{#raw title}}</div>' +
		'<div class="service_content">{{#raw description}}</div>' +
		'<div class="service_link">' +
			'<a href="{{linkUrl}}" target="{{target}}" {{#if target == "_blank"}}class="outlink"{{/if}}">' +
				'<span>이동하여 확인하기</span>' +
			'</a>' +
		'</div>'

  // 전체보기/닫기 버튼
  //prettier-ignore
  var moreTemplate =
    '<div class="result-allview" data-all-result-cnt="{{count}}">' +
      '<a href="#n">{{unitName}} 전체보기<em>({{count}})</em></a>' +
    "</div>" +
    '<div class="result-allview fixed" style="display:none;">' +
      '{{#if !notAllBtn}}<a href="#n">전체보기 닫기</a>{{/if}}' +
    "</div>";

  // 피드백 input
  //prettier-ignore
  var feedbackInputTemplate =
    "{{#each (item, idx) in feedback}}<li>" +
      '<span class="rdo-wrap">' +
        '<input type="radio" id="rdo01-{{#raw idx}}" name="rdo01" value="{{item.value}}" {{#if idx == 0}}checked{{/if}}>' +
        '<label for="rdo01-{{#raw idx}}">{{item.label}}</label>' +
      "</span>" +
    "</li>{{/each}}";

  // 갤러리팝업 [BTOCSITE-21785]
  	var galleryPopupTemplate =
   ' <div class="image-detail-wrap" id="imgGalleryPopup" ><div class="image-detail-popup">'+
   '     <div class="black-bg"></div>'+
   '     <div class="image-detail">'+
   '         <header class="image-detail-header">'+
   '             <p class="tit" ></p>'+
   '             <button type="button" class="close-btn"></button>'+
   '         </header>'+
   '         <section class="pop-conts">'+
   '             <div class="pop-visual-wrap">'+
   '                 <div class="zoom-btn-area">'+
   '                     <a href="#" class="zoom-btn zoom-plus" role="button"></a>'+
   '                     <a href="#" class="zoom-btn zoom-minus" role="button"></a>'+
   '                 </div>'+
   '                 <div class="default" id="modal_detail_target">'+
   //360도 view 노출 case
						'<div class="item view">'+
						'   <div class="item-box">'+
						'       <div id="view360" class="view-box">'+
						'           <div class="View360-holder">'+
						'               <div class="View360-canvasHolder">'+
						'                   <canvas class="View360-canvas"></canvas>'+
						'               </div>'+
						'               <div class="View360-borderHolder View360-loadingBackground"></div>'+
						'               <div class="View360-loaderHolder"></div>'+
						'               <div class="View360-fullSizeLoaderHolder"></div>'+
						'               <div class="View360-clickableArea"></div>'+
						'               <div class="View360-navigationHolder">'+
						'                   <div class="View360-navigation">'+
						'                       <div class="View360-navigationPlay View360-navigationBtn"></div>'+
						'                       <div class="View360-navigationPause View360-navigationBtn"></div>'+
						'                       <div class="View360-navigationOpen View360-navigationBtn"></div>'+
						'                       <div class="View360-navigationOpenExit View360-navigationBtn"></div>'+
						'                   </div>'+
						'               </div>'+
						'               <div class="View360-close"></div>'+
						'           </div>'+
						'           <span class="View360-text-info">※ 제품의 대표 색상 및 디자인에 대한 이해를 돕기 위한 예시 이미지입니다.<br>해당 모델 색상은 아래 버튼의 이미지컷을 참고하세요.</span>'+
						'       </div>'+
						'   </div>'+
						'</div>'+

//		비디오 노출 case
							//일반 video
							'<div class="item video"  style="display:none" >'+
							'   <div id="modalVideoBox" class="item-box visual-box">'+
			                 '       <div class="visual-area">'+
				             '           <img src="" style="display:none">'+
				             '           <div class="video-area">'+
				             '               <video autoplay loop playsinline muted>'+
				             '                   <source src="">'+
				             '               </video>'+
				             '           </div>'+
				             '           <div class="vid-control-wrap">'+
				             '               <a href="#" class="btn-play-muted" role="button">오디오 설명이 포함된 동영상 재생</a>'+
				             '               <button type="button" class="btn-pause">동영상 멈춤</button>'+
				             '           </div>'+
				             '       </div>'+
				             '       <div class="subtitle">'+
				             '       </div>'+
							'   </div>'+
							// youtube
							'   <div id="modalYoutubeBox" class="item-box">'+
			                 '       <div class="video-container video-box youtube-box">'+
				             '           <div class="thumnail">'+
				             '               <img src="" alt="">'+
				             '               <a href="#none" data-src="" class="see-video acc-video-content" title="Opens in a new layer popup" role="button" data-video-content="acc-video" data-type="youtube" data-link-area="" data-link-name="" aria-describedby="title01">plays audio description video</a>'+
				             '           </div>'+
				             '           <div class="video-asset video-box-closeset">'+
				             '               <iframe id="videoPlayerCode" frameborder="0" allowfullscreen="1" allow="accelerometer;encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="640" height="360" src=""></iframe>'+
				             '           </div>'+
			                 '       </div>'+
							'   </div>'+

							'</div>'+

							//image 노출 case
   '                     <div class="item image">'+
   '                         <div class="item-box zoom-area" ui-modules="PinchZoom">'+
   '                             <img src="" alt="" class="image-box">'+
   '                         </div>'+
   '                     </div>'+
   '                 </div>'+

   '                 <div class="thumbnail-nav">'+
   '                     <div class="swiper image-detail-thumb">'+
   '                         <div class="swiper-wrapper">'+
   '							{{#each (item, idx) in galleryImages}}  '+
   '								{{#if item.contentType == "360" }}  '+
									'<div class="swiper-slide thumbnail view {{#if idx == 0}} active {{/if}}">'+
									'   <a href="javascript:void(0)">'+
									'       <img src="/lg5-common/images/icons/icon-360-60.svg" alt="360도">'+
											'<span class="blind">{{item.productCode}}</span>\n' +
									'   </a>'+
									'</div>'+
									'{{#elsif item.contentType == "video"}}'+
									'<div class="swiper-slide thumbnail {{#if item.videoType == "YouTube"}} youtube {{#else}} video {{/if}} {{#if idx == 0}} active {{/if}}">'+
									'   <a href="javascript:void(0)">'+
								//	'       <img src="/lg5-common/images/KRP0008/@dummy-thum05.jpg" alt="">'+
		                                    '{{#if item.videoType == "YouTube"}}' +
		                                    	'<span class="blind">{{item.videoDesc}}</span>\n'+
			                                '{{#else}}'+
			                                    '<img src="{{item._videoThumbnailImage}}" class="lazyload" alt="">\n'+
			                                '{{/if}}'+
									'   </a>'+
									'</div>'+
									'{{#else}}'+
	   '                             <div class="swiper-slide thumbnail image{{#if idx ===0 }} active{{/if}}">'+
	   '                                 <a href="javascript:void(0)">'+
	   '                                     <img src="{{item._imageUrl}}"  data-largeImageUrl="{{item._largeImageUrl}}"   onError="lgkorUI.addImgErrorEvent(this );"  class="lazyload" alt="{{item._imageUrl}}">'+
	   '                              </a></div>'+
   '                              	{{/if}}'+
   '							{{/each}}'+

   '                         </div>'+
   '                     </div>'+
   '                     <div class="swiper-button-next image-thumb-btn"></div>'+
   '                     <div class="swiper-button-prev image-thumb-btn"></div>'+
   '                 </div>'+
   '             </div>'+
   '         </section>'+
   '     </div>'+
   ' </div></div>';

    // 갤러리컬렉션상품 [BTOCSITE-21785]
    var galleryPrdTemplate =
  	'<div class="swiper-slide">' +

  	  '<div class="prd-wrap">' +
  	      '<div class="prd-area">' +
  	          '<a href="{{item.pdpUrl}}">' +
  	              '<span class="prd-img">' +
  	                  '<img src="{{item._imageUrl}}"    onError="lgkorUI.addImgErrorEvent(this );"  class="lazyload" alt="{{item.category_name}}">' +
  	              '</span>' +
  	              '<h4 class="prd-title">{{item.category_name}}</h4>' +
  	              '<div class="prd-price">{{#if item.sell_flag ==="Y" && item.obs_original_price > 0}}' +
  	                  '{{#if item._price != item.obs_original_price }} <span class="before-price">{{vcui.number.addComma(item.obs_original_price)}}원</span>{{/if}}' +
  	                  '<span class="price">{{vcui.number.addComma(item._price)}}원</span>' +
  	              '{{/if}}</div>' +
  	          '</a>' +
  	      '</div>' +
  	      '<div class="buy-area">' +
  	          '<button type="button" class="cart-btn" {{#if item.sell_flag ==="Y" && item.obs_original_price > 0}}{{#else}} disabled{{/if}} data-id="{{item.id}}" data-sku="{{item.sku}}">' +
  	              '<img src="/lg5-common/images/gallery-cart.png">' +
  	          '</button>' +
  	          '<a href="javascript:void(0)" class="buy-now-btn{{#if item.sell_flag ==="Y" && item.obs_original_price > 0}}{{#else}} disabled{{/if}}" data-id="{{item.id}}" data-sku="{{item.sku}}" >바로구매</a>' +
  	      '</div>' +
  	  '</div> ' +
  	'</div>';
  // 갤러리컬렉션팝업 [BTOCSITE-21785]
  var galleryCollectionPopupTemplate =

		'<!-- //BTOCSITE-21785 갤러리 영역 --> <div class="gallery-detail-wrap">'+
		'  <div class="gallery-detail-popup">'+
		'      <div class="black-bg"></div>'+
		'      <div class="gallery-detail">'+
		'          <div class="gallery-head">'+
		'              <h2>갤러리상세</h2>'+
		'              <button type="button" class="close-btn">'+
		'                  <img src="/lg5-common/images/gallery-close.svg" alt="close">'+
		'              </button>'+
		'          </div>'+
		'          <div class="gallery-body">'+
		'              <div class="review">'+
		'                  <span class="upload-img">'+
		'                      <img     alt="{{detail.imageAlt}}" src="{{detail._imageUrl}}" >'+
		'                  </span>'+
		'                  <div class="user">'+
		'                      <div class="user-name">'+
		'                          <span class="profile">'+
		'                              <img src="/lg5-common/images/gallery-user-profile.png">'+
		'                          </span>'+
		'                          <p class="name">{{detail.gallery_user_id}}</p>'+
		'                      </div>'+
		'                      <div class="user-review">'+
		'                          {{#raw detail.gallery_content}}'+
		'                      </div>'+
		'                      {{#if detail.hashTags.length > 0}}<div class="user-tag">  '+
		'                        	 {{ detail._hashTags}}'+
		'                      </div>{{/if}}'+
		'                  </div>'+
		'              </div>'+
		'              {{#if similar.length > 0}} <div class="prd-picture product">'+
		'                  <h3>사진 속 제품</h3>'+
		'                  <div class="swiper product-swiper prd-picture-swiper">'+
		'                      <div class="swiper-wrapper">{{#each item in inPicture}} '+
		galleryPrdTemplate+
		'                      {{/each}}</div>'+
		'                  </div>'+
		'                  <div class="swiper-button-next swiper-arrow-btn prd-picture-next"></div>'+
		'                  <div class="swiper-button-prev swiper-arrow-btn prd-picture-prev"></div>'+
		'              </div>{{/if}}'+
		'              {{#if inPicture.length > 0}} <div class="prd-similar product">'+
		'                  <h3>비슷한 제품</h3>'+
		'                  <div class="swiper product-swiper prd-similar-swiper">'+
		'                      <div class="swiper-wrapper">{{#each item in similar}}'+
		galleryPrdTemplate+
		'                      {{/each}}</div>'+
		'                  </div>'+
		'                  <div class="swiper-button-next swiper-arrow-btn prd-similar-next"></div>'+
		'                  <div class="swiper-button-prev swiper-arrow-btn prd-similar-prev"></div>'+
		'              </div>{{/if}}'+
		'          </div>'+
		'      </div>'+
		'  </div>'+
		'</div><!-- //BTOCSITE-21785 갤러리 영역 --> ';

  // 동영상 - 엘라쇼 [BTOCSITE-44448] LG전자 공식 유튜브 연동
  // BTOCSITE-47951 엘라쇼 히스토리 백 및 앵커링
  // [BTOCSITE-54944]엘라쇼 > 라이브 쇼핑 명칭변경
  // prettier-ignore
  var tempLiveCommerce = '<strong>라이브 쇼핑</strong>' +
  	  '<div class="ellarshow-area">' +
  		  '<ul class="result-list ellarshow">' +
  		      '{{#each (item, idx) in liveCommerce}}' +
  		          '{{#if item.live_yn == "Y"}}' +
	  		          '<li class="schedule" data-id="ellarshow-{{#raw idx}}">' +
	  		              '<a href="{{item.link_url}}">' +
	  		                  '<div class="ellar-info">' +
	  		                      '<span class="img"><img src="{{item.image_url}}" alt="{{item.title}}"></span>' +
	  		                      '<div class="schedule-info">' +
	  		                         // '<span class="ico-ellashow">LG LIVE 쇼핑</span>' +
	  		                          '<span class="s-date">{{item.live_date}}</span>' +
	  		                          '<span class="s-time">{{item.live_time}}</span>' +
	  		                      '</div>' +
	  		                      '<span class="play-time">방송예정</span>' +
		  		              '</div>' +
		  		              '<p class="tit">{{#raw item.title}}</p>' +
		  		          '</a>' +
	  		          '</li>' +
  		          '{{/if}}' +
  		          '{{#if item.live_yn == "N"}}' +
  		              '<li data-id="ellarshow-{{#raw idx}}">' +
  		                  '<a href="javascript:void(0)" data-href="{{item.video_url}}">' +
  		                      '<div class="ellar-info">' +
  		                          '<span class="img"><img src="{{item.image_url}}" alt="{{item.title}}"></span>' +
  		                          '<span class="play-time">{{item.duration}}</span>' +
	  		                  '</div>' +
	  		                  '<p class="tit">{{#raw item.title}}</p>' +
	  		              '</a>' +
  		              '</li>' +
		          '{{/if}}' +
  		      '{{/each}}' +
              '<li class="last" data-id="ellarshow-last">' +
                  '<a href="/livecommerce">' +
                      '<div class="ellar-info">' +
                         // '<span class="ico-ellashow">LG LIVE 쇼핑</span>' +
                          '<p><span>라이브 쇼핑<br/>홈으로 가기</span></p>' +
                      '</div>' +
                  '</a>' +
              '</li>' +
  		  '</ul>' +
  	  '</div>';

  // 최근검색어 저장 공유 도메인 e.g. ".lge.co.kr"
  var lgeHost = location.hostname.replace(/.+(?=lge\.)/i, ".");

  var linkHost =
    window.LGEAPPHostName === "localhost" ? "https://wwwdev50.lge.co.kr" : "";
  var search;
  $(document).ready(function () {
    search = {
      init: function () {
        var self = this;

        self.uniqId = vcui.getUniqId(8); // 세션에 검색 내용 저장을 위한 키
        self.savedFilterData = null; // 저장된 필터 데이터 // {support: ['', ..], ..}
        self.savedSmartFilterData = null; // 저장된 스마트 필터 데이터 // {product: ['', ..], ..}
        self.sortData = null; // 저장된 정렬 데이터 // {product: 'best', support: 'date' ...}
        self.fixedAreaH = 0; // 상단 sticky 높이
        self.device = "";
        self.intersection = null; // filter 활성화/비활성화 intersection
        self.moreIntersection = null; // 전체보기 닫기 버튼 intersection
        self.breakIntersection = false; // 유닛탭 클릭 시 intersection 안먹게하는 flag 변수
        self.moreUnitName = null; // 전체보기 중인 유닛
        self.modalUnitName = null; // 팝업 중인 유닛
        self.scrollDirection = "up"; // 스크롤 방향 // "up" 기본이어야 최상위(first) 체크 가능
        self.uiState = {
          doc: {
            ypos: 0, // 화면 scroll ypos
          },
          product: {
            listIndex: 0, // 리스트 활성화 (아코디언)
            tabIndex: 0, // 리스트 내 탭 활성화
            story: {
              id: null, // 리스트 내 스토리 아이디
              page: 0, // 리스트 내 스토리 탭 컨텐츠 페이징
              scrollX: 0, // 리스트 내 스토리 탭 컨텐츠 스크롤
            },
          },
//        subspackage: { //BTOCSITE-33608 LG UP 가전 2.0 구독	//[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
//            listIndex: 0, // 리스트 활성화 (아코디언)
//        },
          subscribe: {
              listIndex: 0, // 리스트 활성화 (아코디언)
              tabIndex: 0, // 리스트 내 탭 활성화
          },
          gallery: {
              objctId: 0, // 갤러리 오브젯 아이디
              index: 0, //선택  번호
          },
          modal: {
            scrollY: 0, // 팝업 scroll ypos
          },
          video: {//[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
        	  scrollX: 0, // 엘라쇼 scroll xpos
          },
        };
        self.unitSort = []; // 유닛 정렬 순서
        self.scrollAction = 1;  //스크롤 처음 체크
        $(window).scrollTop(0); //BTOCSITE-2216

        /*
        [최적화] js 로드 일원화
          아래 js파일 서버 사이드 등록 필요
          "ui/pagination",
          "ui/rangeSlider",
          "libs/intersection-observer-0.0.0.min",
          "libs/swiper-8.2.4.min",
          "libs/lodash-1.8.3.min",
          "search/modules/plpItem-VIO23"
        */
        vcui.require(
          [
            "ui/pagination",
            "ui/rangeSlider",
          ],
          function () {
            self.plpObj = plpItemVIO23;
            self.setting();
            self.bindEvents();

            self.setUnitSort(true); // self.unitSort 초기 설정 용도

            var hash = location.hash.replace("#", "");
            var savedData = lgkorUI.getStorage(hash) || {}; // 체크 여부 판단!

            //[BTOCSITE-46679] 검색 > 서비스게이트 연결용 URL 생성요청
            // unit[대상Unit], type[filterId], value[filterValueId]
            // "product":{"category":"CT50000025@PRODUCT]TV"}
            //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
            if (lgkorUI.getParameterByName("unit") !== "" && lgkorUI.getParameterByName("type") !== "" && lgkorUI.getParameterByName("value") !== "") {
            	savedData = {
                        search: lgkorUI.getParameterByName("search"),
                        force: "false",
                        sort: JSON.stringify(self.getSortValues()),
                        filterData: '{"unit":{"검색결과":"product||subscribe||disposable||support||event||video||gallery||shop||story||livelg||company"},' +
                        		    '"'+lgkorUI.getParameterByName("unit")+'":{"'+lgkorUI.getParameterByName("type")+'":"'+lgkorUI.getParameterByName("value")+'"}}',
                };
            }

            if (savedData.hasOwnProperty("search") && savedData.search !== "") {
              // 세션에 검색 정보 존재 시

              // 정렬
              self.sortData = JSON.parse(savedData.sort);

              // 필터 데이터 저장
              self.setSavedFilterData(
                JSON.parse(self.makeArrFilterData(savedData.filterData)),
                JSON.parse(self.makeArrFilterData(savedData.smartFilter))
              );

              // 저장된 스크롤 위치 정보
              if (savedData.href) self.scrollHref = savedData.href;

              // 저장된 검색어 정보
              if (savedData.search) {
                self.$inputSearch.val(savedData.search);
                self.$inputSearchFixed.val(savedData.search);
              }

              // console.log("!!!!! Session ::: ");

              // 세센에 의한 검색
              self.requestSearchData(
                savedData.search,
                savedData.force,
                savedData
              );
            } else {

              //입력된 검색어값 조회
              var value =
                lgkorUI.getParameterByName("search") ||
                self.$contentsSearch.attr("data-search-value");

              value = !value ? null : value.trim();
              var force = lgkorUI.stringToBool(
                self.$contentsSearch.attr("data-search-force")
              );

              // 정렬
              self.sortData = self.getSortValues();

              if (!!value) {
                // data-search-value 혹은 url 파라미터 검색어로 검색
                self.setinputSearchValue(value);
                self.requestSearchData(value, force);
              } else {
                // 검색어 없음
                self.setinputSearchValue("");
                self.requestSearchData("", force);
              }
            }

            // as-is : 성능개선(LCP)로 인하여 검색 input 클릭시 검색 레이어 데이터 갱신 되도록처리
            // to-be : [BTOCSITE-37929] 성능개선
            // self.updateBasicData();  <-- 혹시 모르니 소스 주석으로 유지함.
            self.breakpointChecker();
            self.srchTooltip();
            self.gallerySwiper();
          }
        );
      },

      setting: function () {
        var self = this;

        //타이머
        self.searchTimer = null;

        //통합검색 레이어
        self.$contentsSearch = $("div.contents.search");
        //탭
        // self.$tab = self.$contentsSearch.find(".ui_tab").vcTab();

        //input-keyword
        self.$inputKeyword = self.$contentsSearch.find(
          "div.input-keyword:eq(0)"
        );
        //검색어 입력input
        self.$inputSearch = self.$inputKeyword.find("div.input-sch input.txt");
        //스크롤 fixed 검색어 입력창
        var inputSearchFixed = self.$contentsSearch.find(
          "div.input-keyword:eq(1)"
        );
        self.$inputSearchFixed = inputSearchFixed.find(
          "div.input-sch input.txt"
        );

        //검색버튼
        self.$buttonSearch = self.$inputKeyword.find(
          "div.input-sch button.btn-search"
        );
        self.$cameraSearch = self.$inputKeyword.find(
          "div.input-sch button.btn-camera"
        );
        self.$buttonSearchFixed = inputSearchFixed.find(
          "div.input-sch button.btn-search"
        );

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 레이어 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        //검색어 리스트 레이어
        self.$searchInputLayer = self.$inputKeyword.find(
          "div.search-input-layer"
        );
        //검색어 최근,인기,많이 찾는 증상 컨테이너
        self.$searchKeywordArea = self.$searchInputLayer.find(
          "div.search-keyword-area"
        );
        //최근 검색어 리스트
        self.$recentKeywordList =
          self.$searchKeywordArea.find("div.recent-keyword");
        //인기 검색어 리스트
        self.$popularKeywordList = self.$searchKeywordArea.find(
          "div.popular-keyword"
        );
        //많이 찾는 증상 리스트
        self.$topicKeywordList = self.$searchKeywordArea.find(
          "div.symptom-keyword"
        );
        //자동 완성 리스트
        self.$autoComplete = self.$searchInputLayer.find("div.auto-complete");
        //검색어 결과 없음
        self.$notResult = self.$searchInputLayer.find("div.not-result");
        //검색어 리스트 닫기 버튼
        self.buttonClose = self.$searchInputLayer.find(".layer_close");
        //>>>>>>>>>>>>>>>>>>>>>>>>>>>> 레이어 >>>>>>>>>>>>>>>>>>>>>>>>>>>>

        //cont-wrap
        self.$contWrap = self.$contentsSearch.find("div.cont-wrap");
        self.$searchResultWrap = self.$contWrap.find("div.search-result-wrap");
        self.$fixedArea = self.$contWrap.find(".result-area > .list-sorting");

        //필터
        self.$layFilter = self.$contWrap.find("div.lay-filter");
        //A필터
        self.$aFilterTab = self.$contWrap.find("div.nafilter_tabs");
        //필터 안내 BTOCSITE-19776
        self.$layFilter.$layFilterInfo = $("#smartfilter-info");
        //검색어 영역 컨테이너
        self.$inputKeywordWrap = self.$contentsSearch.find(
          "div.input-keyword-wrap"
        );

        //연관검색어 리스트
        self.$relatedKeywordList = self.$inputKeywordWrap.find(
          "div.related-keyword"
        );
        //데체키워드
        self.$searchSimilar = self.$inputKeywordWrap.find("div.search-similar");
        //모바일용 연관검색어 펼치기 버튼
        self.$relatedKeywordMobileMoreButton = self.$relatedKeywordList.find(
          "div.mobile-more-btn"
        );

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 결과없음 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        // nodata 컨테이너
        self.$searchNotResult = self.$contentsSearch.find(
          "div.search-not-result"
        );
        // 이런 제품 어떠세요
        self.$listNoData = self.$contentsSearch.find("div.list-no-data");

        //nodata - "" 검색결과가 없습니다.
        self.$searchWordArea = self.$searchNotResult.find(".search_word_area");
        //nodata - 다시 한번 확인해 주세요.
        self.$searchAgainMsg = self.$searchNotResult.find(
          ".search_word_msg:eq(0)"
        );

        //nodata - 검색어를 입력해주세요
        self.$searchNotNone = self.$searchNotResult.find("span.txt-none");

        //nodata - 결과를 찾으셨나요?
        self.$searchNotSimilar = self.$searchNotResult.find(
          "span.search-similar"
        );
        //nodata - 결과를 찾으셨나요? 앞 <em>
        self.$searchNotResultText = self.$searchNotSimilar.find(
          "em.search-result-text"
        );
        //nodata - 결과를 찾으셨나요? 아래 검색결과로 이동 링크
        self.$searchNotSimilarA = self.$searchNotResult.find("a.similar-text");
        //>>>>>>>>>>>>>>>>>>>>>>>>>>>> 결과없음 >>>>>>>>>>>>>>>>>>>>>>>>>>>>

        self.$autoComplete.hide();
        self.$notResult.hide();

        //배너
        self.$searchBanner = self.$contentsSearch.find("div.search-banner");

        //검색 결과 - 카테고리
        self.$searchResultCategory = self.$contentsSearch.find(
          "div.search-result-category"
        );
        //카테고리 더보기 버튼
        //self.$searchResultCategoryMore = self.$searchResultCategory.find('a.btn-moreview');

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 신규 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        self.$unitListWrap = self.$searchResultWrap.find(
          ".result-list-wrap:not(.list-no-data) > .list-wrap"
        );
        
        // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상 Start
        // List product
        self.$listProduct = self.$searchResultWrap.find(
          ".result-list-wrap > .list-wrap"
        );
        // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상 End

        // 고객 피드백
        self.$feedbackBoxWrap = self.$contentsSearch.find(".feedback-box-wrap");
        // BTOCSITE-23248  이메일 상담
        self.$emailConsultingWrap = self.$contentsSearch.find(".email-consulting-wrap");
        // 서비스 검색
        self.$resultService = self.$contentsSearch.find(".result_service");
        // 배너
        self.$resultBanner = self.$contWrap.find(".result-banner");
        // AI
        self.$resultAI = self.$contWrap.find(".result-ai");
        // 고객지원 컨텐츠
        self.$customerSupport = self.$contWrap.find(".customer-support");
        //>>>>>>>>>>>>>>>>>>>>>>>>>>>> 신규 >>>>>>>>>>>>>>>>>>>>>>>>>>>>

        // 챗봇
        self.$chatbotBox = self.$resultService.find(".chatbot_box");
        self.$chatbotCustomer = self.$chatbotBox.find("a.box_customer");
        self.$chatbotPurchase = self.$chatbotBox.find("a.box_purchase");
        // [BTOCSITE-39081] 2.0 챗봇 연계
        self.$chatbotShopservice = $("#chatbotShopservice");

        // 갤러리  [BTOCSITE-21785]
        self.$galleryWrap = self.$contentsSearch.find(".gallery-wrap");
        self.$galleryWrap.$galleryInfo = $("#galleryPrd-info");
        self.$galleryWrap.$galleryCollectionInfo = $("#galleryCollection-info");
      },

      bindEvents: function () {
        var self = this;

        //검색어 창 동기화
        self.$inputSearch.on("input change", function (e) {
          self.$inputSearchFixed.val($(this).val()).trigger("update");
        });
        self.$inputSearchFixed.on("input change", function (e) {
          self.$inputSearch.val($(this).val()).trigger("update");
        });

        //검색버튼
        self.$buttonSearch.on("click", function (e) {
          e.preventDefault();
          clearTimeout(self.searchTimer);

          var searchVal = self.$inputSearch.val();
          self.sendKeyword(searchVal, "1", "1"); //[BTOCSITE-59848] 검색어 집계 세분화
          self.requestSearchInput(searchVal ,"N");
        });

        // 카메라버튼
        self.$cameraSearch.on("click", function (e) {
          var target = $(e.currentTarget);

          self.callCheckLogin(function (result) {
            var uri = "/my-page/manage-products";

            if (!result.data.isLogin) {
              lgkorUI.alert(
                "<h6>보유제품을 등록하시려면<br />로그인이 필요합니다.</h6>",
                {
                  ok: function () {
                    // 보유제품 페이지로 던지면 미로그인시 로그인 페이지로 가기에
                    if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
                  },
                },
                target
              );
            } else {
              if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
            }
          });
        });

        // <- 버튼
        self.$inputKeyword.on("click", ".btn-back", function (e) {
          e.preventDefault();

          historyBack();
        });

        self.$inputSearch.keydown(function (key) {
          if (key.keyCode == 13) {
            key.preventDefault();
            self.$buttonSearch.trigger("click");
          }

          //BTOCSITE-27053 키보드
          if (key.keyCode == 38 || key.keyCode == 40) {
            var $links = self.$autoComplete.find('div.keyword-list ul li'),
            linkIndex =   0
            count = $links.length;
            if(count > 0 ){
              $links.each(function( index, element ) {
                if ($(element).hasClass("on") ) linkIndex = index+1;
                $(element).removeClass("on")
              });
              switch (key.keyCode) {
                  case 38:
                      // up
                      linkIndex = Math.max(0, linkIndex - 1) ;
                      break;
                  case 40:
                      // down
                      linkIndex = Math.min(count, linkIndex + 1) ;
                      break;
              }
              if(linkIndex > 0 ) linkIndex = linkIndex -1;
              $links.eq(linkIndex).addClass('on');
              self.setinputSearchValue($links.eq(linkIndex).find('a').attr("href").replace("#", ""));
            }
          }
        });

        self.$buttonSearchFixed.on("click", function (e) {
          clearTimeout(self.searchTimer);
          var searchVal = self.$inputSearch.val();
          self.requestSearchInput(searchVal);
        });

        self.$inputSearchFixed.keydown(function (key) {
          if (key.keyCode == 13) {
            key.preventDefault();
            self.$buttonSearchFixed.trigger("click");
          }
        });

        //검색 타이머
        self.$inputSearch.on("input", function (e) {
          clearTimeout(self.searchTimer);

          //[BTOCSITE-34189] 자동완성 공백 특수문자 단독 입력시 호출되지 않도록 처리
          var reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
          var searchVal = this.value.trim();
          var searchTestVal = searchVal.replace(reg, "");
          if (searchVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH || searchTestVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH) {
              // [BTOCSITE-37929] 성능개선 1차 > 검색 입력창 클릭시 검색시 레이어 결과 호출
              var $list_ul = self.$popularKeywordList.find("div.keyword-list ul");
              if( $list_ul.children().length == 0 ) {
                  self.updateBasicData();
              }
              self.searchTimer = setTimeout(function () {
                  self.$searchKeywordArea.show();
                  self.$autoComplete.hide();
                  self.$notResult.hide();
                  self.openSearchInputLayer(true);
                  self.toggleCamera(true);
              }, 600);
          } else {
            self.searchTimer = setTimeout(function () {
              self.requestSearchAutoComplete(searchVal);
            }, lgkorUI.SEARCH_AUTOCOMPLETE_TIMER);
            self.toggleCamera(false);
          }
        });

        //검색어 리스트 닫기 버튼
        self.buttonClose.on("click", function (e) {
          clearTimeout(self.searchTimer);
          self.openSearchInputLayer(false);
          self.$inputSearch.focus();
        });

        //최근검색어 클릭
        self.$recentKeywordList.on(
          "click",
          "div.keyword-list ul li span a",
          function (e) {
            e.preventDefault();
            self.searchItem($(this));
            
            //[BTOCSITE-59848] 검색어 집계 세분화
            var searchVal = $(this).attr("href").replace("#", "");
            self.sendKeyword(searchVal, "3", "1");
          }
        );

        //최근검색어 삭제 클릭
        self.$recentKeywordList.on(
          "click",
          "div.keyword-list ul li span button",
          function (e) {
            var text = $(this)
              .siblings("a")
              .first()
              .attr("href")
              .replace("#", "");
            self.removeRecentSearcheText(text);
          }
        );

        // 최근검색어 전체 삭제
        self.$recentKeywordList.on("click", ".all-delete > a", function () {
          self.removeRecentSearcheText();
        });

        //인기검색어 클릭
        self.$popularKeywordList.on(
          "click",
          "div.keyword-list ul li a",
          function (e) {
            e.preventDefault();
            self.searchItem($(this));
            
            //[BTOCSITE-59848] 검색어 집계 세분화
            var searchVal = $(this).attr("href").replace("#", "");
            self.sendKeyword(searchVal, "3", "2");
          }
        );

        //자동완성 리스트 클릭
        self.$autoComplete.on(
          "click",
          "div.keyword-list ul li a",
          function (e) {
            e.preventDefault();
            self.searchItem($(this));
            
            //[BTOCSITE-59848] 검색어 집계 세분화
            var searchVal = $(this).attr("href").replace("#", "");
            self.sendKeyword(searchVal, "3", "4");
          }
        );

        //자동완성 화살표 클릭
        self.$autoComplete.on(
          "click",
          "div.keyword-list ul li button",
          function (e) {
            e.preventDefault();

            self.searchItem($(this).prev("a"), false);
            self.openSearchInputLayer(false);
            self.$inputSearch.focus();
          }
        );

        //연관검색어 리스트 클릭
        self.$relatedKeywordList.on("click", "ul li a", function (e) {
          e.preventDefault();
          self.searchItem($(this));
          
          //[BTOCSITE-59848] 검색어 집계 세분화
          var searchVal = $(this).attr("href").replace("#", "");
          self.sendKeyword(searchVal, "3", "3");
        });

        //대체키워드 클릭
        self.$contentsSearch.on("click", "a.similar-text", function (e) {
          e.preventDefault();

          var searchVal = $(this).attr("href").replace("#", "");

          self.setinputSearchValue(searchVal);
          self.sendKeyword(searchVal, "3", "5"); //[BTOCSITE-59848] 검색어 집계 세분화
          //현재 선택된 카테고리 기준으로 검색
          self.requestSearchData(searchVal, true);
        });

        //전체보기 열고/닫기 클릭
        self.$searchResultWrap.on(
          "click",
          ".list-wrap .result-allview > a",
          function (e) {
            e.preventDefault();

            var target = $(this).parent();
            var $plpCont = target
              .closest(".list-wrap")
              .find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
            var plp = $plpCont.data("instance");
            var unitName = plp.getUnit();

            if (!target.hasClass("fixed")) {
              // 전체보기 로딩중 리스트 영역을 밖으로 나갔을 경우 대비
              var st = $(document).scrollTop();
              var DONE = plp.event.DONE;
              $plpCont.one(DONE, function () {
                if (target.next().hasClass("outside")) {
                  // 영역을 벗어났으면 원 위치로
                  $(document).scrollTop(st);
                }
              });

              self.moreList(unitName); // 전체보기 열기
            } else {
              self.closeList(unitName); // 전체보기 닫기
            }
          }
        );

        //메뉴얼, 드라이버 등의 파일 다운로드
        self.$searchResultWrap.on(
          "click",
          ".list-wrap div.btn-area button",
          function (e) {
            var url = $(this).attr("data-file-url");
            if (!!url) {
              window.location = url;
            }
          }
        );

        // [BTOCSITE-44448] LG전자 공식 유튜브 연동
        // [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
        self.$searchResultWrap.on(
          "click",
          ".list-wrap div.video-list-area ul.result-list:not(.ellarshow) a",
          function (e) {
            var videoTit = $(this).find('.txt-info').children('.tit').text();
            var videoId = $(this).attr('data-videoId');
            var url = "https://www.youtube.com/embed/"+videoId+"?autoplay=1&mute=1&rel=0";
            if (self.device == "mobile") {
            	url = url + "&fs=0";
            }else {
            	url = url + "&modestbranding=1";
            }
            var ytIframe = '<iframe width="100%" height="100%" src="'+url+'" title="'+videoTit+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen tabindex="0"></iframe>';
            var pcPlayArea = $('.pc-player');
            var mobPlayArea = $('.mob-player');
            var mobPlayer = $(this).find('.mob-player');	//mobile용

            //초기화 - pc
            $('.archive-list-wrap').find('li').removeClass('active');
            $(this).parent().siblings().removeClass('active');
            pcPlayArea.removeClass('active').removeAttr('style').empty();

            //초기화 - mobile
            mobPlayArea.empty();

            if($(window).width() > 768) {
                var posLeft = $(this).parent().position().left + 24;
                var posWidth = $('.archive-list-wrap').width();
                var videoPlayArea = '';
                videoPlayArea += '<div class="inner">';
                videoPlayArea += '<div class="player-inner">'+ytIframe+'</div>';
                videoPlayArea += '</div>';
                videoPlayArea += '<button type="button" class="btn-video-cls"><span class="blind">동영상 영역 닫기</span></button>';

                $(this).parent().addClass('active')
                $(this).siblings('.pc-player').empty().css({left: -posLeft, width: posWidth}).addClass('active').append(videoPlayArea);
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('.pc-player.active').offset().top - ($('.input-keyword-wrap').outerHeight() / 2)
                    }, 400);
                }, 600);

                $('.pc-player').on('click', '.btn-video-cls', function() {
                	var _this = $(this);
                    _this.parent().removeClass('active').removeAttr('style').empty().parent().removeClass('active');
                });
            } else {	//self.device == "mobile"
                $('.archive-list-wrap').find('.mob-player').find('iframe').each(function() {
                    $(this)[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                });

                mobPlayer.append(ytIframe);
                $(this).parent().addClass('active');
            }
          }
        );

        // [BTOCSITE-44448] LG전자 공식 유튜브 연동
        $(window).resize(function() {
        	if($(window).width() > 768) {
        		//초기화 - mobile
        		$('.mob-player').empty();

				var archiveItem = $('.archive-list-area').children('.result-list').children('li');
	          	var archiveActiveItem = $('.archive-list-area').children('.result-list').children('li.active');
				if(archiveActiveItem.length > 0) {
					var acchivePlayer = archiveActiveItem.children('.pc-player');
					var activePlayerPosLeft = acchivePlayer.parent().position().left + 24;
					var resultWidth = $('.archive-list-wrap').width();

					archiveActiveItem.children('.pc-player').css({left: -activePlayerPosLeft, width: resultWidth});
				}
        	}else {
        		//초기화 - pc
        		$('.archive-list-wrap').find('li').removeClass('active');
                $('.pc-player.active').removeClass('active').removeAttr('style').empty();
        	}
        });

        // 고객지원 컨텐츠 - 제품 문제 해결하기 버튼 클릭
        self.$customerSupport.on("click", "> a", function (e) {
          e.preventDefault();

          var $unitListWrap = self.$searchResultWrap.find(
            ".result-list-wrap > .list-wrap"
          );

          if (!$unitListWrap.eq(0).hasClass("support")) {
            self.upperUnit("support");

            // 스크롤 이동
            self.filterLayer.changeUnitTab("support");
          } else {
            var unitNameArr = self.unitSort.concat([]).reverse();
            unitNameArr.forEach(function (unitName) {
              self.upperUnit(unitName);
            });
          }
        });

        // 리스트 하단 배너 클릭
        self.$searchResultWrap.on(
          "click",
          ".cs-banner li > a, .shopservice-banner li > a",
          function (e) {
            self.saveUIState();
          }
        );

        // 고객 피드백
        self.$feedbackBoxWrap.on("click", ".search-btn", function (e) {
          var target = $(e.currentTarget);
          var checkedRadio = target
            .siblings(".select-list-wrap")
            .find("input[type=radio]:checked");

          var contentTextArea = target
            .siblings(".feedback-input")
            .find("textarea");

          if (checkedRadio.length && contentTextArea.length) {
            self.requestFeedBack(checkedRadio.val(), contentTextArea.val());
          }
        });

        //리스트 정렬 선택시 필터의 정렬 값도 선택하게함
        self.$searchResultWrap.on("change", ".ui_selectbox", function (e) {
          var target = $(e.currentTarget);
          var $plpCont = target.closest(".list-wrap").find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
          var unitName = $plpCont.data("unit");

          self.filterLayer.triggerChangeEvent({ unit: unitName }, false); //[BTOCSITE-59848] 검색어 집계 세분화
          
          //[BTOCSITE-59848] 검색어 집계 세분화
          var searchVal = self.$contentsSearch.attr("data-search-value").trim();
          self.sendKeyword(searchVal, "2", "2", unitName);
        });

        // 팝업 오픈 리스너
        var $popup = $(".morelist-layer");
        $popup
          .off("modalshow")
          .on("modalshow", self.openPopupComplete.bind(self));

        var scrollStatus = new ScrollStatus();
        scrollStatus.init({
          namespace: "search",
          initUpdate: true,
          exChange: function (data) {
            if (data.direct && self.scrollDirection !== data.direct) {
              if (!data.scrolling && self.device === "mobile") {
                self.scrollDirection = data.direct;

                self.initIntersection();
              } else if (self.device === "pc") {
                self.scrollDirection = data.direct;

                self.initIntersection();
              }
            }
          }.bind({ self: self }),
        });

        //스크롤 이벤트
        $(window).on("scroll.search", function (e) {
          if (self.device === "pc") scrollStatus.update();

          self.scrollToToggle();
        });

        $(window).on("resize.search", function (e) {
          self.winH = $(window).height();
        });

        //비교하기 컴포넌트 변화 체크
        $(window).on("changeStorageData", self.setCompares.bind(self));

        // 미디어 쿼리
        $(window).on(
          "breakpointchange.search",
          self.breakpointChecker.bind(self)
        );

        //검색 이동 로그 쌓기
        $("body").on(
          "click",
          "ul.result-list a, ul.morelist_wrap a",
          function (e) {
            self.sendLog(this);
            var href = $(this).attr("href");

            if (href && href.indexOf("#") !== 0) {
              if (
                $(this).hasClass("ios_blank") &&
                isApp() &&
                vcui.detect.isIOS
              ) {
                e.preventDefault();

                // IOS 앱 인경우 링크 처리
                var jsonString = JSON.stringify({
                  command: "sendOutLink",
                  url: href,
                });
                webkit.messageHandlers.callbackHandler.postMessage(jsonString);
              } else {
                self.saveUIState();
              }
            }
          }
        );

        //상단 체크 //BTOCSITE-32032 내일 배송 확대
        self.$contWrap.on("click", "#tomorrow_chk02", function (e) {
           self.tomorrowChk(e);
        });
        // 내일 배송 체크 박스
        self.$unitListWrap.on("click", "#tomorrow_chk01", function (e) {
          self.tomorrowChk(e);
        });

        //BTOCSITE-48682 다품목할인 상단 체크
        self.$contWrap.on("click", "#multi_product_chk02", function (e) {
           self.multiItemChk(e);
        });
        //BTOCSITE-48682 다품목할인 체크 박스
        self.$unitListWrap.on("click", "#multi_product_chk01", function (e) {
          self.multiItemChk(e);
        });

        self.$contWrap.on("click", "#employee_chk02", function (e) {
            self.employeeChk(e);
         });
        self.$unitListWrap.on("click", "#employee_chk01", function (e) {
           self.employeeChk(e);
        });
        // 비교하기 상태 변화 리스너
        $(".component.KRP0015").on(
          "DOMSubtreeModified propertychange",
          function (e) {
            var $target = $(e.currentTarget);
            var transition = window.getComputedStyle($target.get(0)).transition;

            if (transition && transition.indexOf("all") == 0) {
              if ($target.find(".is-active").length) {
                //console.log("열림");
                self.$contentsSearch
                  .removeClass("compare-close")
                  .addClass("compare-open");
              } else {
                //console.log("닫힘");
                self.$contentsSearch
                  .removeClass("compare-open")
                  .addClass("compare-close");
              }
            } else {
              //console.log("사라짐");
              self.$contentsSearch.removeClass("compare-open compare-close");
            }
          }
        );

        // 비교하기 후 돌아왔을 때 상태 기억 위한 리스너
        $(".component.KRP0015").on("click", ".btn-compare", function () {
          self.saveUIState();
        });

        // 챗봇
        self.$chatbotCustomer.on("click", function(e) {
          e.stopPropagation();
          e.preventDefault();
          lgkorUI.goChatbot(lgkorUI.CHATBOT_SERVICE_LIST[0]); // 고객지원 챗봇
        });

        self.$chatbotPurchase.on("click", function(e) {
          e.stopPropagation();
          e.preventDefault();
          //lgkorUI.goChatbot(lgkorUI.CHATBOT_SERVICE_LIST[1]); // 마케팅 챗봇
          lgkorUI.goChatbot(); // [BTOCSITE-39081] 2.0 챗봇 연계
        });
        // [BTOCSITE-39081] 2.0 챗봇 연계
        self.$chatbotShopservice.on("click", function(e) {
            e.stopPropagation();
            e.preventDefault();
            lgkorUI.goChatbot(); // 상담 챗
        });

        //갤러리 유닛  [BTOCSITE-21785]
        self.$galleryWrap.on("click", ".gallery-review .prd-btn",  function(e) {  //갤러리 오브젝 각 버튼
            var prd_btn = $('.gallery-wrap .gallery-review .prd-btn');
            var img_box = $('.gallery-wrap .gallery-review .img-box').height()*0.5;

            var prd_individual_popup =  $(this).next('.prd-individual-wrap').children('.prd-individual-popup');
            $(this).siblings('.prd-individual-wrap').children('.prd-individual-popup').removeClass('active');
            $(this).siblings('.prd-btn').removeClass('active');

            if ( !$(this).hasClass('active') ) {
                $(this).addClass('active');
                //오브젯 안 상품 클릭 시 변경
                prd_individual_popup.addClass('active');
                $(this).parent(".img-box").next().attr("href", prd_individual_popup.attr("data-modelUrlPath"))
                $(this).parent(".img-box").next().find(".prd-title").text(  prd_individual_popup.attr("data-displayName") );
                $(this).parent(".img-box").next().find(".prd-number").text(  prd_individual_popup.attr("data-modelName") );
                if(parseInt(prd_individual_popup.attr("data-totalPrice") ) > 0 ){
                    $(this).parent(".img-box").next().find(".prd-price").text(  prd_individual_popup.attr("data-totalPrice") +"원");
                }else{
                    $(this).parent(".img-box").next().find(".prd-price").text(  "");
                }
                // 스토리지지 저장
                self.uiState.gallery.objctId = $(this).siblings('.thumb-btn').attr("data-gallery-id");
                self.uiState.gallery.index = $(this).attr("data-index");
                self.saveUIState();
            } else {
               // $(this).removeClass('active');
                //prd_individual_popup.removeClass('active');
            }
        });

        // 갤러리 탭 영역  [BTOCSITE-21785]
        self.$unitListWrap.filter(".product").on("click", ".gallery .mo-img-box  > a",  function(e) {
        	self.requestGalleryCollectionInfo($(this).attr("data-gallery-id") ,$(this).parents('.cnt-wrap').offset().top);
        });
        // 갤러리 탭 > 썸네일 클릭시 갤러리 팝업     [BTOCSITE-21785]
        self.$unitListWrap.filter(".product").on("click", ".gallery .gallery-std .gallery-swiper .swiper-slide > a",  function(e) {
        	var gallery_tab_slide = $('.gallery .gallery-std .gallery-swiper .swiper-slide');
            var isMobile = window.breakpoint.isMobile;
            if(isMobile ){
            	$(this).parents(".gallery-std").siblings(".mo-img-box").find(".img-box > img").attr("src" ,$(this).find(".img-box > img").attr("src")) ;
            	$(this).parents(".gallery-std").siblings(".mo-img-box").find("a").attr("data-gallery-id",$(this).attr("data-gallery-id")) ;
                gallery_tab_slide.removeClass('active');
                $(this).parents(".swiper-slide").addClass('active');
            }else{
            	self.requestGalleryCollectionInfo( $(this).attr("data-gallery-id") ,$(this).parents('.swiper-slide').offset().top );
            }

        });
        //  갤러리 유닛 > 썸네일 클릭시 갤러리 컬랙션 팝업       [BTOCSITE-21785]
        self.$galleryWrap.on("click", ".gallery-review .thumb-btn",  function(e) {
        	self.requestGalleryCollectionInfo($(this).attr("data-gallery-id") , $(this).parents('.gallery-item').offset().top );
        });
        // 갤러리 유닛 > 썸네일 클릭시 갤러리 팝업 ( 상품) [BTOCSITE-21785]
        self.$galleryWrap.on("click", ".gallery-product .thumb-btn",  function(e) {   // 썸네일 클릭시 갤러리 팝업 ( 상품)
        	//var ajaxUrl = "/search/prdObjetGalleryDetail.lgajax";
        	var ajaxUrl = self.$contentsSearch.attr("data-gallery-url");
 //           var ajaxUrl ="/lg5-common/data-ajax/search/galleryImages_info.json";
        	var popupTitle = $(this).attr("data-main-model-name");// 타이틀
        	var popupId = $(this).attr("data-main-model-id");
            var image_thumb_btn_top = $(this).parents('.gallery-item').offset().top;
      	  	var param = {
                  "id":popupId
              }
            //ajax호출
            lgkorUI.requestAjaxData(ajaxUrl, param, function (result) {
            	self.saveUIState(); // 스토리지 저장
            	var item = result.data;
            	item._imageUrl= '';
                item.galleryImages.forEach(function (obj, idx)  {
                	var isMobile = window.breakpoint.isMobile;
                    if(isMobile ){
	                	if (item._imageUrl == "" && obj.contentType =="image" )item._imageUrl  = linkHost + obj.zoomMobImageAddr;
	                	obj._largeImageUrl = linkHost + obj.zoomMobImageAddr;
                    }else{
	                	if (item._imageUrl == "" && obj.contentType =="image" )item._imageUrl  = linkHost + obj.zoomImageAddr;
	                	obj._largeImageUrl = linkHost + obj.zoomImageAddr;
                    }
                    obj._videoThumbnailImage = linkHost + obj.videoThumbnailImage;
                    obj._videoUrl = linkHost + obj.videoUrl;
                    obj._imageUrl = linkHost + obj.smallImageAddr;
                    obj._largeImageAddr = linkHost + obj.largeImageAddr;

                  });
            	self.$galleryWrap.$galleryInfo.html(   vcui.template( galleryPopupTemplate,  item )        );

                self.imageDetailWrap = $('.image-detail-wrap');
                $('html, body').css({'overflow':'hidden', 'touch-action':'none'}); // 바닥페이지 스크롤 제어
                $('.image-detail-wrap').children('.image-detail-popup').fadeIn(500);
                $('.image-detail-popup').on('scroll touchmove mousewheel', function(e){
                    e.preventDefault();
                });
                lgkorUI.showAppBottomMenu(false); // 이미지썸네일 클릭시 앱바 투명도0/터치x

                //self.imageDetailWrap.find(".pop-conts > img ").attr("alt" ,popupTitle );// 타이틀
                self.imageDetailWrap.find('.image-detail-header  .tit').html(popupTitle);// 타이틀
                var search_height = $('.input-keyword-wrap.re22.scroll').outerHeight();
                var nafilter_tabs_height = $('.cont-wrap .nafilter_tabs').outerHeight();
                var nafilter_choice_height = $('.cont-wrap .nafilter_choice').outerHeight();
                var filter_all_height = search_height + nafilter_tabs_height + nafilter_choice_height;
                var maxWidth1024 = matchMedia("screen and (max-width: 1024px)").matches;
                var iamge_close_btn = $('.image-detail-popup .image-detail-header .close-btn');
                iamge_close_btn.click(function(){ // 이미지 팝업 - x버튼 클릭시 팝업 hide
                  $('.image-detail-popup').hide();
                  $('html, body').css({'overflow':'','touch-action':''}); // 바닥페이지 스크롤 원상복구
                  $('.image-detail-popup').off('scroll touchmove mousewheel');

                  if( maxWidth1024 ){ //화면 크기가 1024px이하일때
                      $(window).scrollTop(image_thumb_btn_top - filter_all_height);
                  }
                  lgkorUI.showAppBottomMenu(true);// 이미지썸네일 클릭시 앱바 투명도0/터치x
	            });
	              // -------------------------------------------------------------------//

	            var image_black_bg = $('.image-detail-popup .black-bg');
	              	image_black_bg.click(function(){ // 이미지 팝업 - 배경(검은색) 클릭시 팝업 hide
	                  $('.image-detail-popup').hide();
	                  $('html, body').css({'overflow':'','touch-action':''}); // 바닥페이지 스크롤 원상복구
	                  $('.image-detail-popup').off('scroll touchmove mousewheel');

	                  if( maxWidth1024 ){ //화면 크기가 1024px이하일때
	                      $(window).scrollTop(image_thumb_btn_top - filter_all_height);
	                  }
	                  lgkorUI.showAppBottomMenu(true); // 이미지썸네일 클릭시 앱바 투명도0/터치x
	              });
	            var image_black_bg2 = self.imageDetailWrap.find(" .swiper-wrapper > div > a  ");
	            	image_black_bg2.click(function(){
	            		var index = popupGallery.el.$popupImgList.find("a").index(this);
	                	self.imageDetailWrap.find(".pop-conts .item-box  img").attr("src" ,$(this).attr("data-largeImageUrl")) ;
	                	popupGallery.setModalVisual(index);
                });


                self.imageDetailWrapDefault = self.imageDetailWrap.find('.default')
                self.imageDetailWrapImage = self.imageDetailWrapDefault.find('.item.image');

                self.thumbnailNav = self.imageDetailWrap.find('.thumbnail-nav');
                self.thumbnailSlide = self.thumbnailNav.find('.thumbnail');

                self.imageDetailZoomArea = self.imageDetailWrap.find('.zoom-btn-area');
                self.imageDetailZoomPlus = self.imageDetailZoomArea.find('.zoom-plus');
                self.imageDetailZoomMinus = self.imageDetailZoomArea.find('.zoom-minus');
                // 썸네일 이미지 클릭시(360/video/이미지)
                self.thumbnailSlide.click(function(){
                	self.thumbnailSlide.removeClass('active');
                	$(this).addClass('active')
                });

                // 이미지팝업 썸네일 스와이퍼
                var image_detail_thumb = new Swiper(".image-detail-thumb", {
                  slidesPerView: 'auto',
                  spaceBetween: 8,
                  slidesPerGroup: 1,
                  observer: true,
                  observeParents: true,
                  watchSlidesProgress: true,

                  navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  },
                });
                // 핀치줌
                vcui.require(['ui/pinchZoom'], function (PinchZoom) {
                    self.pinchZoom = new PinchZoom('.zoom-area');
                    popupGallery.el.$pinchZoom  =self.pinchZoom ;
                    self.imageDetailZoomPlus.on('click', function(e){
                        e.preventDefault();
                        var zoom =self. pinchZoom.getZoomFactor();
                        if(Math.round(zoom) >= 4) zoom = 0;
                        self.pinchZoom.runZoom(zoom+1, true);
                    });

                    self.imageDetailZoomMinus.on('click', function(e){
                        e.preventDefault();
                        var zoom =self.pinchZoom.getZoomFactor();
                        self.pinchZoom.runZoom(zoom-1, true);
                    });

                    self.imageDetailWrapImage.mousedown(function() {
                        self.isDragging = false;
                    })
                    .mousemove(function() {
                        self.isDragging = true;
                    })
                    .mouseup(function() {
                        var wasDragging = self.isDragging;
                        self.isDragging = false;
                        if (!wasDragging) {
                            self.imageDetailZoomPlus.trigger('click');
                        }
                    });
                });

                var popupGallery ={
                		el: {
                			 $container: null                // 컨테이너
                          ,  $popupVisual360 : null          // 갤러리뷰 360 노출 영역
                          , $popupVisualVideo : null        // 갤러리뷰 비디오 노출 영역
                          , $popupVisualImage : null        // 갤러리뷰 이미지 노출 영역
                          , $popupMainImg : null            // 팝업 메인
                          , $popupImgList : null            // 팝업 이미지 리스트
                          , $popupZoomArea : null           // 갤러리뷰 줌 영역
                          , $view360 : null                 // 갤러리뷰 360
                          , $pinchZoom : null               // 갤러리뷰 핀치 줌 영역
                        },

                        selector: {
                        	 container : '#imgGalleryPopup'
                          , view360 : '#view360'
                          , popupImgList : '.image-detail-thumb .swiper-wrapper'
                          , popupZoomArea : 'div.zoom-btn-area'
                          , popupVisual360 : '#modal_detail_target div.view'
                          , popupMainImg : '#modal_detail_target .item-box img'
                          , popupVisualVideo : '#modal_detail_target div.video'
                          , popupVisualImage : '#modal_detail_target div.image'
                        },
                        init: function() {
                        	this.el.$container = $(this.selector.container).first();
                            this.el.$view360 = $(this.selector.view360).first();
                            this.el.$popupMainImg = this.el.$container.find(this.selector.popupMainImg);
                            this.el.$popupVisual360 = this.el.$container.find(this.selector.popupVisual360);
                            this.el.$popupVisualVideo = this.el.$container.find(this.selector.popupVisualVideo);
                            this.el.$popupVisualImage = this.el.$container.find(this.selector.popupVisualImage);
                            this.el.$popupZoomArea = this.el.$container.find(this.selector.popupZoomArea);
                            this.el.$popupImgList = this.el.$container.find(this.selector.popupImgList);


                        },
                		  // modal visual 영역 노출
                        setModalVisual : function(index){
                            var item =  result.data.galleryImages[index];
                            var contentType = item.contentType;
                            var $modalVideoBox = $("#modalVideoBox");
                            var $modalYoutubeBox = $("#modalYoutubeBox");

                            // 영상 url 처리
                            $modalVideoBox.find('video').attr('src','');
                            $modalVideoBox.find('source').attr('src','');
                            $modalYoutubeBox.find('iframe').attr('src','');

                            if (contentType == "360") { // 360
                                popupGallery.el.$popupMainImg.attr("src", item._largeImageAddr);
                                popupGallery.open360Resize();
                                popupGallery.el.$popupVisual360.show();
                                // 영상 영역 비노출
                                $modalVideoBox.hide();
                                $modalYoutubeBox.hide();
                                popupGallery.el.$popupVisualVideo.hide();
                                // 이미지 영역 숨김처리
                                popupGallery.el.$popupZoomArea.hide();
                                popupGallery.el.$popupVisualImage.hide();
                            } else if(contentType == "video"){ // video
                                if(item.videoType == "VideoFile" ){ // mp4
                                    $modalVideoBox.find('div.visual-area img').attr("src", item._videoThumbnailImage);
                                    if(item.videoDesc   ){
                                    	$modalVideoBox.find('div.subtitle').show();
                                    	$modalVideoBox.find('div.subtitle').html(item.videoDesc);
                                    }else{
                                    	$modalVideoBox.find('div.subtitle').hide();
                                    }

                                    $modalVideoBox.find('source').attr({
                                        'src' : item._videoUrl,
                                        'type' : 'video/' + item.videoType
                                    });
                                    $modalVideoBox.find('video').attr('src', item._videoUrl);
                                    $modalVideoBox.find('div.video-area video')[0].play();
                                    $modalVideoBox.find('.vid-control-wrap button').removeClass('btn-play');
                                    $modalVideoBox.find('.vid-control-wrap button').addClass('btn-pause');
                                    // 영상 음소거 토글 버튼
                                    $modalVideoBox.find('.vid-control-wrap a').off('click').on('click', function(){
                                        if($(this).hasClass('btn-play-muted')) {
                                            $("#modalVideoBox").find('.vid-control-wrap a').removeClass('btn-play-muted');
                                            $("#modalVideoBox").find('.vid-control-wrap a').addClass('btn-play-sound');
                                            $("#modalVideoBox").find('div.video-area video')[0].muted = true;
                                        } else {
                                            $("#modalVideoBox").find('.vid-control-wrap a').removeClass('btn-play-sound');
                                            $("#modalVideoBox").find('.vid-control-wrap a').addClass('btn-play-muted');
                                            $("#modalVideoBox").find('div.video-area video')[0].muted = false;
                                        }
                                    });
                                    // 영상 재생/멈춤 버튼
                                    $modalVideoBox.find('.vid-control-wrap button').off('click').on('click', function(){
                                        if($(this).hasClass('btn-play')) {
                                            $("#modalVideoBox").find('.vid-control-wrap button').removeClass('btn-play');
                                            $("#modalVideoBox").find('.vid-control-wrap button').addClass('btn-pause');
                                            $("#modalVideoBox").find('div.video-area video')[0].play();
                                        } else {
                                            $("#modalVideoBox").find('.vid-control-wrap button').removeClass('btn-pause');
                                            $("#modalVideoBox").find('.vid-control-wrap button').addClass('btn-play');
                                            $("#modalVideoBox").find('div.video-area video')[0].pause();
                                        }
                                    });
                                    $modalVideoBox.show();
                                    $modalYoutubeBox.hide();
                                }else{ // youtube
                                    $modalYoutubeBox.find('div.thumnail img').attr("src", item._videoThumbnailImage);
                                    $modalYoutubeBox.find('iframe').attr("src", item.videoUrl+ '?autoplay=0&mute=1');
                                    $modalYoutubeBox.find('.see-video').attr({
                                        'data-src': item.videoUrl,
                                        'data-link-name': item.videoDesc
                                    });
                                    $modalYoutubeBox.show();
                                    $modalVideoBox.hide();
                                }
                                popupGallery.el.$popupVisualVideo.show();
                                // 360 정지
                                popupGallery.open360Stop();
                                popupGallery.el.$popupVisual360.hide();
                                // 이미지 영역 숨김처리
                                popupGallery.el.$popupZoomArea.hide();
                                popupGallery.el.$popupVisualImage.hide();

                            } else { // image
                                // 팝업메인 이미지

                            	//self.pinchZoom.runZoom(1, false);
                                popupGallery.el.$popupMainImg.attr("src", item._largeImageUrl);
                                popupGallery.el.$popupZoomArea.show();
                                popupGallery.el.$popupVisualImage.show();
                                // 360 정지
                                popupGallery.open360Stop();
                                popupGallery.el.$popupVisual360.hide();
                                // 영상 영역 비노출
                                $modalVideoBox.hide();
                                $modalYoutubeBox.hide();
                                popupGallery.el.$popupVisualVideo.hide();
                                self.pinchZoom.update(true);
                            }
                        },

                		  open360: function() {
                              var self = this;
                              self.view = new View360();
                              self.view.setConfig({
                                  width: popupGallery.el.$view360.scrollWidth,
                                  height: popupGallery.el.$view360.scrollHeight,
                                  columns: result.data.galleryImages[0].rotateTotal,
                                  open_cols: result.data.galleryImages[0].openTotal,
                                  pathType: result.data.galleryImages[0].pathType,
                              });
                              self.view.setNavigationConfig({
                                  showOpen: result.data.galleryImages[0].openTotal > 1 ? true:false,
                                  showTurnLeft: result.data.galleryImages[0].openTotal > 1 ? true:false,
                              });
                              self.view.setImagesDirectory( linkHost + result.data.galleryImages[0].productPath + result.data.galleryImages[0].productCode );
                              self.view.start(popupGallery.el.$view360[0]);
                              popupGallery.el.$view360.append('<span class="View360-text-info">※ 제품의 대표 색상 및 디자인에 대한 이해를 돕기 위한 예시 이미지입니다.<br>해당 모델 색상은 아래 버튼의 이미지컷을 참고하세요.</span>');
                          },
                          open360Stop: function() {
                              var self = this;
                              if(popupGallery.el.$view360.length && self.view) {
                                  self.view.stopAutoRotate();
                                  self.view.lastCol = 0;
                                  self.view.latestImageIdx = 0;
                                  self.view.currentCol = 0;
                                  self.view.currentRow = 0;
                                  self.view.displayCurrentImage();
                              }
                          },
                          open360Resize: function() {
                              var self = this;
                              if(popupGallery.el.$view360.length) {
                                  var w = $('#imgGalleryPopup').width();
                                  var p = 0 ; //Number($('#imgGalleryPopup').find('.default').css('padding-left').replace('px','') * 2);
                                  var ww = (w > 450)? 540 : w - p , hh = (w > 450) ? 540 : w - p;
                                  popupGallery.el.$view360.css({
                                      'width':ww,
                                      'height':hh
                                  })
                                  if ( !!self.view ) {
                                      self.view.setConfig({
                                          width:  ww,
                                          height: hh
                                      });
                                  };
                                  self.view.updateCanvasSize();
                                  self.view.displayCurrentImage();
                              }
                          }

                };

                popupGallery.init();

                if (item.galleryImages[0].contentType == "360") {
                    if(popupGallery.el.$view360.length) {
                        vcui.require([
                            '/lg5-common/front/360view/js/View360.js'
                        ], function () {
                            popupGallery.open360();
                            popupGallery.setModalVisual(0);
                        });
                    }
                }else{
                	popupGallery.setModalVisual(0);
                }
            });
        });
        //[BTOCSITE-46564] [개발] 검색 > 가격필터(LG UP가전 2.0 구독 / 케어십 구독)
        $('#layerNoDataPopup').on('click','.btn',function(){
			$('#layerNoDataPopup').vcModal('hide');
			// 결과 있는 이전 필터 데이터
			var savedData = lgkorUI.getStorage(self.uniqId);
			if (savedData.preFilterData) {
				self.requestReSearchData(_.cloneDeep(savedData.preFilterData));
			}
	    });
        // [BTOCSITE-37929] 성능개선 1차 > 검색 입력창 클릭시 검색시 레이어 결과 호출
        self.$inputSearch.on('click', function() {
            var $list_ul = self.$popularKeywordList.find("div.keyword-list ul");
            if( $list_ul.children().length == 0 ) {
                self.updateBasicData();
            }
        });
      },

      //BTOCSITE-32032 내일배송
      tomorrowChk: function ( e) {
    	  var self = this;
          var target = $(e.currentTarget);
          var checked = target.prop("checked");

          // 특정 필터 input 변경 발생
          self.filterLayer.changeFilterInput(
            "product",
            "producttype",
            "tomorrow",
            checked
          );
      } ,
      //BTOCSITE-48682 다품목할인
      multiItemChk: function ( e) {
    	  var self = this;
          var target = $(e.currentTarget);
          var checked = target.prop("checked");

          // 특정 필터 input 변경 발생
          self.filterLayer.changeFilterInput(
            "product",
            "producttype",
            "multiItem",
            checked
          );
      } ,
      employeeChk: function ( e) {
    	  var self = this;
          var target = $(e.currentTarget);
          var checked = target.prop("checked");

          // 특정 필터 input 변경 발생
          self.filterLayer.changeFilterInput(
            "product",
            "producttype",
            "employee",
            checked
          );
      } ,
      // 썸네일 클릭시 갤러리 컬랙션 팝업 정보  [BTOCSITE-21785]
      requestGalleryCollectionInfo: function (galleryId ,thumb_btn_top) {
    	var self = this;
    	var ajaxUrl = self.$contentsSearch.attr("data-gallery-collection-url");
    	//var ajaxUrl ="/search/retrieveObjetGalleryDetail.lgajax";
    	  ///search/retrieveObjetGalleryDetail.lgajax?id=OG00000022
  	  	var param = {
              "id":galleryId
          }
//	      var ajaxUrl ="/lg5-common/data-ajax/search/galleryCollection_info.json?id="+galleryId;
	      //ajax호출
	      lgkorUI.requestAjaxData(ajaxUrl, param, function (result) {
	    	 self.saveUIState(); // 스토리지 저장
	      	var data = result.data;
	      	data.detail._imageUrl = linkHost + data.detail.imageUrl ;
	      	data.detail._hashTags = vcui.string.replaceAll( data.detail.hashTags.toString() , ',', '');
	      	data.inPicture.forEach(function (obj, idx)  {
	      		obj._price = self.galleryPrdPrc (parseInt(obj.obs_discount_price), parseInt(obj.obs_member_price), parseInt(obj.obs_original_price), parseInt(obj.obs_special_discount));

	      		obj._imageUrl  = linkHost + obj.imageUrl;
	          });
	      	data.similar.forEach(function (obj, idx)  {
	      		obj._price = self.galleryPrdPrc (parseInt(obj.obs_discount_price), parseInt(obj.obs_member_price), parseInt(obj.obs_original_price), parseInt(obj.obs_special_discount));

	      		obj._imageUrl  = linkHost + obj.imageUrl;
	          });
	      	self.$galleryWrap.$galleryCollectionInfo.html(   vcui.template( galleryCollectionPopupTemplate,  data)        );

	      	  $('html, body').css({'overflow':'hidden', 'touch-action':'none'}); // 바닥페이지 스크롤 제어
	      	  $('.gallery-detail-wrap').children('.gallery-detail-popup').fadeIn(500);

	            lgkorUI.showAppBottomMenuOver(false); // 앱 하단메뉴가 화면을 덮는 형태인지 아닌지 여부
	            lgkorUI.setEnableAppScrollBottomMenu(false); // 앱 하단메뉴 스크롤 기능 사용 여부
	            lgkorUI.showAppBottomMenu(false); // 앱 하단메뉴 노출 여부

	      	 // var thumb_btn_top = $(this).parents('.gallery-item').offset().top;
	            var gallery_close_btn = $('.gallery-detail-popup .gallery-head .close-btn');
	            var search_height = $('.input-keyword-wrap.re22.scroll').outerHeight();
	            var nafilter_tabs_height = $('.cont-wrap .nafilter_tabs').outerHeight();
	            var nafilter_choice_height = $('.cont-wrap .nafilter_choice').outerHeight();
	            var filter_all_height = search_height + nafilter_tabs_height + nafilter_choice_height;
	            var maxWidth1024 = matchMedia("screen and (max-width: 1024px)").matches;
	            gallery_close_btn.click(function(){ // 갤러리 팝업 - x버튼 클릭시 팝업 hide
	                $('.gallery-detail-popup').hide();
	                $('html, body').css({'overflow':'','touch-action':''}); // 바닥페이지 스크롤 원상복구
	                if( maxWidth1024 ){ //화면 크기가 1024px이하일때
	                    $(window).scrollTop(thumb_btn_top - filter_all_height);

	                }
                      lgkorUI.showAppBottomMenuOver(true); // 앱 하단메뉴가 화면을 덮는 형태인지 아닌지 여부
                      lgkorUI.setEnableAppScrollBottomMenu(true); // 앱 하단메뉴 스크롤 기능 사용 여부
                      lgkorUI.showAppBottomMenu(true); // 앱 하단메뉴 노출 여부
	            });
	            var gallery_black_bg = $('.gallery-detail-popup .black-bg');
	            gallery_black_bg.click(function(){ // 갤러리 팝업 - 배경(검은색) 클릭시 팝업 hide
	                $('.gallery-detail-popup').hide();
	                $('html, body').css({'overflow':'','touch-action':''}); // 바닥페이지 스크롤 원상복구
	                if( maxWidth1024 ){ //화면 크기가 1024px이하일때
	                    $(window).scrollTop(thumb_btn_top - filter_all_height);
	                }

                      lgkorUI.showAppBottomMenuOver(true); // 앱 하단메뉴가 화면을 덮는 형태인지 아닌지 여부
                      lgkorUI.setEnableAppScrollBottomMenu(true); // 앱 하단메뉴 스크롤 기능 사용 여부
                      lgkorUI.showAppBottomMenu(true); // 앱 하단메뉴 노출 여부

	            });

	            // -------------------------------------------------------------------//

	            //장바구니
	            self.$galleryWrap.$galleryCollectionInfo.off("click").on("click", ".cart-btn",  function(e) {
	          	  self.requestCart(this);
	            });
	            //주문하기
	            self.$galleryWrap.$galleryCollectionInfo.on("click", ".buy-now-btn",  function(e) {
	          	  self.requestBuy(this);
	            });
	            if($(".prd-picture-swiper").length > 0 ){
		            var prd_picture_swiper = new Swiper(".prd-picture-swiper", { // 사진 속 제품
		                observer: true,
		                observeParents: true,
		                watchSlidesProgress: true,

		                navigation: {
		                    nextEl: ".swiper-button-next.prd-picture-next",
		                    prevEl: ".swiper-button-prev.prd-picture-prev",
		                },
		                breakpoints: {
		                    641 :{
		                        slidesPerView: 3,
		                        spaceBetween: 4,
		                    },
		                    280 :{
		                        slidesPerView: 2,
		                        spaceBetween: 0,

		                    }
		                }
		            });
	            }
	            if($(".prd-similar-swiper").length > 0 ){
		            var prd_similar_swiper = new Swiper(".prd-similar-swiper", { // 비슷한 제품
		                observer: true,
		                observeParents: true,
		                watchSlidesProgress: true,

		                navigation: {
		                    nextEl: ".swiper-button-next.prd-similar-next",
		                    prevEl: ".swiper-button-prev.prd-similar-prev",
		                },
		                breakpoints: {
		                    641 :{
		                        slidesPerView: 3,
		                        spaceBetween: 4,
		                    },
		                    280 :{
		                        slidesPerView: 2,
		                        spaceBetween: 0,

		                    }
		                }
		            });
	            }

		      });
	    },
      // 갤러리 할인 가격  [BTOCSITE-21785]
      galleryPrdPrc: function (obs_discount_price , obs_member_price  ,obs_original_price ,obs_special_discount ) {

    	  var discount   =  obs_discount_price+ obs_member_price > 0 ? (obs_discount_price+ obs_member_price) : obs_special_discount;
          return obs_original_price - discount;
      },
      // 장바구니  [BTOCSITE-21785]
      requestCart : function (dm,cartType) {
    	  var self = this;
          var ajaxUrl = self.$contentsSearch.attr("data-cart-url");
          //var ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/commonModule/addCart.lgajax"
          var param = {
              "id":$(dm).attr('data-id'),
              "sku":$(dm).attr('data-sku'),
              "rtSeq":"",
              "typeFlag":"P",
          }

          lgkorUI.requestCart(ajaxUrl, param, true);
      },
      //주문하기   [BTOCSITE-21785]
      requestBuy : function (dm,cartType) {
    	  var self = this;
    	  var ajaxUrl = self.$contentsSearch.attr('data-buy-url');
    	  //var ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/product/addCartDirectPurchase.lgajax"
    	  var param = {
              "order_type":"NB"
          }
    	  var cart = [];
          cart.push({
              "sku":$(dm).attr('data-sku'),
              "quantity":1
          });

          if(cart.length > 0) {
              var cart_items = [];
              cart.forEach(function(obj,idx){
                  cart_items.push({"data":obj});
              });
              param.cart_items = cart_items;
              param.order_item_qty = cart_items.length;
          }
	      if(ajaxUrl) {
	          lgkorUI.showLoading();
	          lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
	              //console.log(result);
	              var data = result.data;
	              var obsDirectPurchaseUrl = data.obsDirectPurchaseUrl;
	              if(obsDirectPurchaseUrl){
	                  location.href = obsDirectPurchaseUrl;
	              }
	          });
	      }
      },
      /**
       * 로그인 체크
       */
      callCheckLogin: function (callback) {
        var ajaxUrl = $("header").data("login-info");

        if (!ajaxUrl) {
          return;
        }

        lgkorUI.requestAjaxDataPost(
          ajaxUrl,
          {},
          function (result) {
            if (callback) callback(result);
          }.bind(this)
        );
      },

      sendLog: function (dm) {
        var self = this;
        var search = self.$contentsSearch.attr("data-search-value");
        var index = $(dm).parents(".result-list").data("unit");
        var param = {
          index: index,
          linkUrl: dm.href,
          search: search,
        };

        var ajaxUrl = self.$contentsSearch.attr("data-log-url");
        if (ajaxUrl) {
          lgkorUI.requestAjaxDataPost(ajaxUrl, param, null, true);
        }
      },
      
      //[BTOCSITE-59848] 검색어 집계 세분화
      //type:1.입력쿼리 > typeDetail:1.검색어입력창
      //type:2.전환쿼리 > typeDetail:1.필터,2.정렬,3.전체보기
      //type:3.클릭쿼리 > typeDetail:1.최근검색어,2.인기검색어,3.연관검색어,4.자동완성,5.대체키워드
      sendKeyword: function (query, type, typeDetail, unit) {
          var site = "web";
          if (isApp()) {
        	  site = "app";
          }else if (vcui.detect.isMobile) {
        	  site = "mobile";
          }
          var param = {
        	query: query,
        	site: site,
        	unit: unit || "all",
        	type: type,
        	typeDetail: typeDetail
          };
          var ajaxUrl = "/search/keywordrecord.lgajax";
          if (ajaxUrl) {
            lgkorUI.requestAjaxDataPost(ajaxUrl, param, null, true);
          }
      },

      breakpointChecker: function () {
        var self = this;
        var breakpoint = window.breakpoint;

        // console.log("!!!!! breakpointChecker :::", breakpoint.name);

        self.device = breakpoint.name;

        switch (breakpoint.name) {
          case "pc":
            self.fixedAreaH = 94;
            break;
          case "mobile":
            if (self.$layFilter.hasClass("hide-tab")) {
              self.fixedAreaH = 58 + 55; // top + tag height
            } else {
              self.fixedAreaH = 58 + 59 + 55; // top + tab + tag height
            }

            break;
          default:
        }

        // rootMargin 재정의를 위한 실행
        self.initIntersection();
      },

		/**
		 * 스크롤 반응하는 요소 컨틀롤
		 */
		scrollToToggle: function () {
			var self = this;
			var scrollTop = $(window).scrollTop();

			self.uiState.doc.ypos = scrollTop;

			var $thresholdTarget = self.$inputKeyword;

			if ($thresholdTarget.length) {
				var threshold =
					self.device === "pc"
					? $thresholdTarget.offset().top + $thresholdTarget.outerHeight()
					: 1;

				// search 영역
				self.$fixedArea.toggleClass("fixed", threshold < scrollTop);

				// bfilter 영역
				// [PC 필터] 검색 결과 없음 얼럿 이후 PC 필터 영역에 제품 영역이 위로 덮어버리는현상으로 주석처리함.(퍼블 수정 요청)
				/*  if (threshold < scrollTop) {
						self.$contWrap.addClass("filter_fixed");
					} else {
						self.$contWrap.removeClass("filter_fixed");
				}*/
			}

			// 필터 스크롤 컨트롤
			if (self.filterLayer && self.filterLayer.loaded) {
				self.filterLayer.scrollHandler();
			}
		},

      //검색어 검색창에 입력하기 (fixed와 같이 동기화 하기 위함)
      setinputSearchValue: function (val) {
        var self = this;
        self.$inputSearch.val(val).change();
      },

      //검색어창에 입력후 검색
      searchItem: function ($item, isTrigger) {
        var self = this;
        var searchVal = $item.attr("href").replace("#", "");
        var trigger = isTrigger === undefined ? true : isTrigger;

        self.setinputSearchValue(searchVal);

        if (trigger) {
        	//self.$buttonSearch.trigger("click");
        	//[BTOCSITE-59848] 검색어 집계 세분화
        	clearTimeout(self.searchTimer);
            self.requestSearchInput(searchVal, "N");
        }
      },

      /**
       * 검색 레이어 데이터 갱신
       */
      updateBasicData: function () {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-basic-url");
        lgkorUI.requestAjaxData(ajaxUrl, null, function (result) {
          var data = result.data;

          // console.log("!!!!! updateBasicData ::: 검색어 리스트 레이어", data);

          //인기검색어
          var arr =
            data.popular && data.popular instanceof Array ? data.popular : [];

          if (arr.length > 0) {
            var $list = self.$popularKeywordList.find("div.keyword-list");
            $list.empty().append("<ul></ul>");
            if (arr.length > 5) $list.append("<ul></ul>"); // 5개 이상 때 추가 ul
            $list_ul = $list.find("> ul");

            arr.forEach(function (item, index) {
              $list_ul.eq(Math.floor(index / 5)).append(
                vcui.template(popularItemTemplate, {
                  text: item,
                  index: index + 1,
                })
              );
            });
            self.$popularKeywordList.show();
          } else {
            self.$popularKeywordList.hide();
          }

          //많이 찾는 증상
          arr = data.topic && data.topic instanceof Array ? data.topic : [];
          if (arr.length > 0) {
            var $list_ul = self.$topicKeywordList.find("ul");
            $list_ul.empty();
            arr.forEach(function (item, index) {
              $list_ul.append(vcui.template(topicItemTemplate, item));
            });
            self.$topicKeywordList.show();
          } else {
            self.$topicKeywordList.hide();
          }
        });
      },

      /**
       * 최근 검색어 추가
       * @param {string} text 검색어
       */
      addRecentSearcheText: function (text) {
        if (!text || text.length < 1) return;
        var self = this;

        // 쿠키 *.lge.co.kr 에 공유하기 위함
        lgkorUI.cookieDomain = lgeHost;

        lgkorUI.addCookieArrayValue(
          lgkorUI.INTERGRATED_SEARCH_VALUE,
          text,
          lgkorUI.MAX_SAVE_RECENT_KEYWORD
        );
        self.updateRecentSearchList();

        lgkorUI.cookieDomain = null;
      },

      /**
       * 최근 검색어 삭제
       * @param {string} text 검색어
       */
      removeRecentSearcheText: function (text) {
        var self = this;

        // 쿠키 *.lge.co.kr 에 공유하기 위함
        lgkorUI.cookieDomain = lgeHost;

        if (text) {
          lgkorUI.removeCookieArrayValue(
            lgkorUI.INTERGRATED_SEARCH_VALUE,
            text
          );
        } else {
          lgkorUI.deleteCookie(lgkorUI.INTERGRATED_SEARCH_VALUE);
        }

        self.updateRecentSearchList();

        lgkorUI.cookieDomain = null;
      },

      /**
       * 최근 검색어 리스트 갱신
       */
      updateRecentSearchList: function () {
        var self = this;
        //var searchedList = localStorage.searchedList ? JSON.parse(localStorage.searchedList) : [];
        var cookieValue = lgkorUI.getCookie(lgkorUI.INTERGRATED_SEARCH_VALUE);
        var searchedList = cookieValue ? cookieValue.split("|") : [];
        //searchedList = vcui.array.reverse(searchedList);

        /* console.log(
          "!!!!! updateRecentSearchList ::: 최근 검색어",
          searchedList
        ); */

        var arr = searchedList instanceof Array ? searchedList : [];
        var $list_ul = self.$recentKeywordList.find("div.keyword-list ul");
        $list_ul.empty();
        if (arr.length > 0) {
          arr.forEach(function (item, index) {
            $list_ul.append(vcui.template(recentItemTemplate, { text: item }));
          });
          self.$recentKeywordList.show();
          self.$recentKeywordList.find("div.no-data").hide();
        } else {
          self.$recentKeywordList.hide();
          self.$recentKeywordList.find("div.no-data").show();
        }
      },

      /**
       * 검색어 줄임
       * @param {string} value 검색어
       * @returns
       */
      ellipsisValue: function (value) {
        if (value.length > 17) {
          return value.substring(0, 18) + "...";
        }
        return value;
      },

      /**
       * 카메라 버튼 토글
       * @param {boolean} show
       */
      toggleCamera: function (show) {
        var self = this;

        if (isApp() && show) {
          self.$buttonSearch.hide();
          self.$cameraSearch.show();
        } else {
          self.$buttonSearch.show();
          self.$cameraSearch.hide();
        }
      },

      openSearchInputLayer: function (open) {
        var self = this;
        if (open) {
          self.updateRecentSearchList();
          self.$searchInputLayer.show();
          self.$inputKeywordWrap.addClass("key-fixed");
          self.$inputKeyword.addClass("focus-on");
        } else {
          self.$searchInputLayer.hide();
          self.$inputKeywordWrap.removeClass("key-fixed");
          self.$inputKeyword.removeClass("focus-on");
        }

        // 영역 밖 외부 클릭 시 닫기
        self.closeSearchInputLayerListener(open);
      },

      /**
       * 검색 레이어 닫기 리스너 등록 & 해제 (document 클릭 시 닫기)
       * @param {boolean} value 이벤트 등록 유무
       */
      closeSearchInputLayerListener: function (value) {
        var self = this;

        if (value) {
          $(document)
            .off("click.search")
            .on("click.search", function (e) {
              var target = $(e.target);

              if (!target.closest(".input-keyword.focus-on").length) {
                self.buttonClose.trigger("click");
              }
            });
        } else {
          $(document).off("click.search");
        }
      },

      /**
       * reload 검색
       * @param {string} searchUrl
       * @param {*} search
       * @param {*} force
       */
      sendSearchPage: function (searchUrl, search, force) {
        if (searchUrl) {
          var fi = searchUrl.indexOf("?");
          var url =
            searchUrl +
            (fi < 0 ? "?" : "&") +
            "search=" +
            encodeURIComponent(search) +
            "&force=" +
            force;

          location.href = url;
        }
      },

      /**
       * 검색어 입력중 자동완성
       * @param {string} value 검색어
       */
      requestSearchAutoComplete: function (value) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-autocomplete-url");
        lgkorUI.requestAjaxData(ajaxUrl, { search: value }, function (result) {
          var param = result.param;
          var data = result.data;

          var searchedValue = param.search;
          var replaceText =
            '<span class="search-word">' + searchedValue + "</span>";

          var showAutoComplete = false;

          //자동완성 리스트 갱신
          var arr = data && data.listData instanceof Array ? data.listData : [];
          var $list_ul = self.$autoComplete.find("div.keyword-list ul");
          $list_ul.empty();
          if (arr.length > 0) {

            arr.forEach(function (item, index) {
              $list_ul.append(
                vcui.template(autoCompleteItemTemplate, {
                  input: item,
                  text: vcui.string.replaceAll(
                    item,
                    searchedValue,
                    replaceText
                  ),
                })
              );
            });
            showAutoComplete = true;
          }
          //자동완성 매핑 상품 리스트
          var arrPrductList = data && data.prductList instanceof Array ? data.prductList : [];
          var $prductList_div = self.$autoComplete.find("div.prod-direct-list");
          var $prductList_ul = self.$autoComplete.find("div.prod-direct-list ul");
          $prductList_ul.empty();
          $prductList_div.hide();
          if (arrPrductList.length > 0) {
        	  $prductList_div.show();
              arrPrductList.forEach(function (item, index) {
            	item._imageUrl = linkHost + item.smallImageAddr;
            	item._modelName =   vcui.string.replaceAll( item.modelName,  searchedValue,  replaceText  );
            	$prductList_ul.append(
                  vcui.template(autoCompletePrductListTemplate, item)
                );
              });
              showAutoComplete = true;
          }
          //자동완성  매핑 브랜드 리스트
          var arrBrandList = data && data.brandList instanceof Array ? data.brandList : [];
          var $brandList_ul = self.$autoComplete.find("div.brandhall");
          $brandList_ul.empty();
          $brandList_ul.hide();
          if (arrBrandList.length > 0) {
        	  $brandList_ul.show();
              arrBrandList.forEach(function (item, index) {
            	  $brandList_ul.append(
                  vcui.template(autoCompleteBrandListTemplate, item)
                );
              });
              showAutoComplete = true;
          }
          self.$searchKeywordArea.hide();

          if (showAutoComplete) {
            //검색결과가 있는 경우.
            self.$autoComplete.show();
            //self.$notResult.hide();
            self.openSearchInputLayer(true);

            // ajax done 이전에 텍스트가 지워졌을 경우 대응 다시 최근,인기,많이 찾는 증상 레이어 노출
            if (!self.$inputSearch.val().length) {
              self.$autoComplete.hide();
              self.$searchKeywordArea.show();
            }
          } else {
            //검색결과를 표시할것이 없을경우
            self.$autoComplete.hide();
            //self.$notResult.show();
            self.openSearchInputLayer(false);
          }
        });
      },

      /**
       * input 박스에 의한 검색 Btocsite 23619- api 두번호출로 api호출 여부예외
       * @param {string} value 검색어
       * @param {string} api호출 여부 Y/N - 디폴트 빈값
       */
      requestSearchInput: function (value , isApi) {
        //BTOCSITE-91 검색 바로가기 개발요청
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-search-url");

        lgkorUI.requestAjaxData(
          linkHost + "/search/searchKeyword.lgajax",
          { keyword: value },
          function (result) {
            if (result.data && result.data.success == "Y" && result.data.url) {
              if (result.data.linkTarget == "self") {
                location.href = result.data.url;
              } else {
                if (isApp()) {
                  if (vcui.detect.isIOS) {
                    var jsonString = JSON.stringify({
                      command: "sendOutLink",
                      url: result.data.url,
                    });
                    webkit.messageHandlers.callbackHandler.postMessage(
                      jsonString
                    );
                  } else {
                    void android.openLinkOut(result.data.url);
                  }
                } else {
                  window.open(result.data.url, "_blank");
                }
              }
            } else {
              // console.log("search btn", value);
            	if(isApi !="N"){
                    lgkorUI.requestAjaxData(
                            ajaxUrl,
                            { search: value },
                            function (result) {
                              self.openSearchInputLayer(false);

                              //검색어 저장
                              self.$contentsSearch.attr("data-search-value", value);
                              self.$contentsSearch.attr("data-search-force", false);

                              self.sendSearchPage(location.pathname, value, false);
                            }
                          );
            	}else{

                    self.openSearchInputLayer(false);

                    //검색어 저장
                    self.$contentsSearch.attr("data-search-value", value);
                    self.$contentsSearch.attr("data-search-force", false);

                    self.sendSearchPage(location.pathname, value, false);
            	}

            }
          }
        );
      },

      /**
       * 전체보기 에 의한 재검색
       * @param {object} data // {unit: 'product', isMore: true}
       */
      requestSearchMore: function (data) {
        var self = this;

        self.filterLayer.triggerChangeEvent(data, false); //[BTOCSITE-59848] 검색어 집계 세분화

        self.moreUnitName = data.unit;

        self.saveUIState();
        
        //[BTOCSITE-59848] 검색어 집계 세분화
        var searchVal = self.$contentsSearch.attr("data-search-value").trim();
        self.sendKeyword(searchVal, "2", "3", data.unit);
      },

      //[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
      getLoginInfo: function() {
      	var self = this;

        self.$contentsSearch.attr("data-partner-type", "");
        self.$contentsSearch.attr("data-partner-cd", "");

       // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
        if (digitalData.userInfo.partnerType != "B2C") {
            self.$contentsSearch.attr("data-partner-type", digitalData.userInfo.partnerType);
            self.$contentsSearch.attr("data-partner-cd", digitalData.userInfo.partnerCode);
        }
      },
		/**
		 * 검색
		 * @param {string} value 검색어
		 * @param {*} force
		 */
		requestSearchData: function (value, force, filterQueryData) {
			// console.log("!!!!! requestSearchData :::", value, filterQueryData);
			var self = this;

			//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
			self.getLoginInfo();

			var ajaxUrl = self.$contentsSearch.attr("data-search-url");
			var postData = {
				search: value,
				force: force,
				partnerType: self.$contentsSearch.attr("data-partner-type"),	//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
				partnerCd: self.$contentsSearch.attr("data-partner-cd"),		//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
				sort: JSON.stringify(self.sortData),
			};

			if (filterQueryData) $.extend(postData, filterQueryData);

			// var careType = lgkorUI.getParameterByName("careType");

			// if (careType) vcui.extend(postData, { careType: careType });

			// 새로 생성된 검색정보(필터 선택 포함) 세션에 저장 후 url#hash 교체
			self.setSessionStorage(postData);
			location.hash = self.uniqId;

			// ajax req 불필요한 데이터 제거
			postData = self.makePayloadData(postData);

			// 레이아웃 초기화
			self.setLayout();

			self.$unitListWrap.hide(); // list wrap 모두 숨김
			self.$contWrap.show();

			lgkorUI.showLoading();
			lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function (result) {
				var data = result.data;
				var param = result.param;
				var inputValue = param.inputValue;
				var splitYN = param.splitYN;
				var searchedValue = param.search;
				//var replaceText = '<span class="search-word">' + searchedValue + "</span>";

				//검색어 저장
				self.$contentsSearch.attr("data-search-value", searchedValue);
				self.$contentsSearch.attr("data-search-force", force);

				// 초기화
				// [2024.02.13] 속도개선-jsp에서 처리
				// self.initRelated(data); // 연관 검색어

				// 대체키워드 존재
				if (inputValue && inputValue != searchedValue) {
					if (splitYN != "Y") {
						// 보정된 키워드로 검색결과 제공
						var $similarP = self.$searchSimilar.find("p:not('.split')");
						$similarP.find(".word_area").html(searchedValue);
						$similarP
							.find("a.search_word_link")
							.html(inputValue + " 검색결과 보기")
							.attr("href", "#" + inputValue);
						$similarP.show();
					} else {
						// 첫 띄어쓰기 전 키워드로 검색결과 제공
						var $splitP = self.$searchSimilar.find("p.split");
						$splitP.find(".word_area").html(inputValue);
						$splitP.find(".search_word_msg em").html(searchedValue);
						$splitP.show();
					}
				}

				var allCount = result.data.allCount;
				self.$searchResultWrap.find(".alllist-count").html("총 " + vcui.number.addComma(allCount) + "개");

				var noData = result.data.noData;
				var noDataCount = parseInt(noData["count"]) || 0;

				// 프로모션 배너
				// [2024.02.13] 속도개선-jsp에서 처리
				// self.initBanner(result);

				if (noDataCount) {
					// 검색 결과 없을 때
					self.initNoData(result);

					self.scrollToToggle();
				} else if (result.data) {
					// 검색 결과 있을 때
					// 서비스 연결
					var serviceTitle =
						result.data.service && result.data.service.hasOwnProperty("title")
						? result.data.service.title
						: null;

					var serviceType =
						result.data.service && result.data.service.hasOwnProperty("type")
						? result.data.service.type
						: null;

					//[BTOCSITE-40108] 검색 > 모바일 하단 여백 오류
					if (serviceType != null) {
						self.$contentsSearch.addClass("service-gate");
					}

					// 서비스 연결 타이틀 데이터가 있거나 || 타입이 챗봇(type4)이면
					if (serviceTitle || serviceType === "type4") {
						self.initService(result);

					} else {
						if (self.filterLayer && self.filterLayer.loaded) {
							// 각각 unit 리스트 생성
							self.initList(result);
						} else {
							// 필터 생성 완료 콜백
							self.$layFilter.off("loaded").on("loaded", function () {
								// 각각 unit 리스트 생성
								self.initList(result);
							});
						}

						// 고객지원 컨텐츠 생성
						self.initSupportContent(result);

						// 필터 초기화
						self.initFilter(result);
					}
				}
				//최근검색어 저장
				self.addRecentSearcheText(inputValue);
				self.setDataLayer();
			});
		},

      /**
       * 필터변경에 의한 재검색
       * @param {object} unitQueryData
       */
      requestReSearchData: function (filterQueryData) {
        var self = this;

        //[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
        self.getLoginInfo();

        var ajaxUrl = self.$contentsSearch.attr("data-search-unit-url");
        var value = self.$contentsSearch.attr("data-search-value").trim();
        var force = self.$contentsSearch.attr("data-search-force");

        // 정렬 셀렉트 변경에 의해 호출 되므로 전체 sort 데이터 재저장
        self.sortData = self.getSortValues();

        // ui상 필터 정보 객체 self 변수에 저장
        self.setSavedFilterData(
          filterQueryData.filterData,
          filterQueryData.smartFilter
        );

        // 필터 데이터 string 형으로 가공
        var filterDatas = self.makeJsonStrFilterData(filterQueryData);

        // 검색 정보 세션 저장
        self.setSessionStorage({
          search: value,
          force: force,
          partnerType: self.$contentsSearch.attr("data-partner-type"),	//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
          partnerCd: self.$contentsSearch.attr("data-partner-cd"),		//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
          sort: JSON.stringify(self.sortData), // 정렬은 전체유닛 저장
          filterData: filterDatas.filterData,
          smartFilter: filterDatas.smartFilter,
        });

        // 특정 유닛만 재검색
        if (filterQueryData.unitFilterData) {
          var unit = filterQueryData.unitFilterData.unit;

          // console.log("!!!!! request Re SearchData :::", unit);

          // 특정 유닛 sort // string 이라 JSON.stringify 불필요
          var sort = self.sortData.hasOwnProperty(unit)
            ? self.sortData[unit]
            : "";

          var $listWrap = self.$unitListWrap.filter("." + unit);
          var $listUL = $listWrap.find("ul.result-list:not(.ellarshow)"); //[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
          //var plp = $listUL.data("instance");

          // 특정 유닛 필터 데이터 string 형으로 가공
          var unitFilterDatas = self.makeJsonStrFilterData(
            filterQueryData.unitFilterData
          );

          // 리스트 갯수가 limit 보다 작을때 최소값 req end 유지
//          var pureListNum = $listUL.find("> li").length;
//          var endNum =
//            self.getUnitLimit(unit) > pureListNum
//              ? self.getUnitLimit(unit)
//              : pureListNum;

          // 특정 유닛 조회 req 데이터
          var postData = {
            search: value,
            force: force,
            partnerType: self.$contentsSearch.attr("data-partner-type"),	//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
            partnerCd: self.$contentsSearch.attr("data-partner-cd"),		//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
            sort: sort,
            unit: unit,
            start: 0,
            end: self.getUnitLimit(unit) - 1,
            filterData: unitFilterDatas.filterData,
            smartFilter: unitFilterDatas.smartFilter
          };

          // ajax req 불필요한 데이터 제거
          postData = self.makePayloadData(postData);

          // 사용한 객체 삭제
          //delete filterQueryData.unitFilterData;	//[BTOCSITE-46564] [개발] 검색 > 가격필터(LG UP가전 2.0 구독 / 케어십 구독)

          // 전체보기 버튼에 의해 호출했을 경우
          var isMore = filterQueryData.isMore;

          if (!isMore) {
            lgkorUI.showLoading();

            // 특정 유닛 기본 재검색
            lgkorUI.requestAjaxDataPost(
              ajaxUrl,
              postData,
              function (result) {
              	//[BTOCSITE-46564] [개발] 검색 > 가격필터(LG UP가전 2.0 구독 / 케어십 구독)
              	if (result.count == 0) {
            		$('#layerNoDataPopup').vcModal('show');
            		return;
            	}else {
            		// 결과 있는 이전 필터 데이터 저장
            		self.setSessionStorage({
            			preFilterData: _.cloneDeep(filterQueryData)
            		});

            		// 사용한 객체 삭제
                    delete filterQueryData.unitFilterData;
            	}

	            // 특정 unit 데이터 갱신 -필터 전에 데이터 갱신 해줘야 필터에서 data 확인 가능
	            var $listWrap = self.$unitListWrap.filter("." + this.unit);
	            var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
	            var plp = $plpCont.data("instance");

	            // 리스트 교체
	            if (plp) {
	              plp.setRentalFilter(self.getRentalFilterChecked()); //BTOCSITE-41977 렌탈 관련 필터 체크시 렌탈탭 디폴트 선택
	              plp.setSubspackageFilter(self.getSubspackageFilterChecked()); //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
	              plp.changeList(result);
	            }
                // 필터 업데이트
                self.updateFilter({ unit: this.unit, res: result });
	            // 특정 unit 리스트 갱신
	            self.updateList({ unit: this.unit, res: result });
                // 재검색 시 filterLayer.inViewBfilterUnit 호출 안되도록
                self.filterLayer.activatedUnitName = null;

                // 스크롤 위치 복구
                self.filterLayer.restoreUIState();

                // 스크롤 반응하는 요소 컨틀롤
                self.scrollToToggle();
                // 비교하기 활성화 버튼 수정
                self.setCompares();
                // 찜하기 활성화 버튼 수정
                self.setWishs();
                // ga 관련 함수 호출
                self.srchTooltip();
                // 갤러리 Swiper
                self.gallerySwiper();
                // 연관 추천 제품 Swiper
                self.relatedSwiper();
                self.setDataLayer();
                
                //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축 - 제품 탭 스크롤 적용
                for(var i = 0; i < $('.ui_smooth_scrolltab').length; i++){
                    var tabIndex = $('.ui_smooth_scrolltab').eq(i).find('.tabs li.on').index();
                    $('.ui_smooth_scrolltab').eq(i).vcSmoothScrollTab('setTabIndex',tabIndex);
                }
              }.bind({ unit: unit })
            );
          } else {
            // 전체보기에 의한 특정 유닛 재검색
            var $listWrap = self.$unitListWrap.filter("." + unit);
            var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
            var plp = $plpCont.data("instance");

            lgkorUI.showLoading();

            var DONE = plp.event.DONE;
            $plpCont.one(DONE, function () {
              self.setCompares();
              self.setWishs();
              self.srchTooltip();
              self.gallerySwiper();
              self.relatedSwiper();
              self.setDataLayer();
            });
            
            // [BTOCSITE-59804] 검색 > 제품 전체보기 필터링 오류
            // 특정 유닛 조회 req 데이터
            var postFilterData = {
              filterData: unitFilterDatas.filterData || {},
              smartFilter: unitFilterDatas.smartFilter || {}
            };
            plp.updateData(postFilterData);

            // ajax 호출
            plp.callAjax();
          }
        } else {
          // 전체 재검색 ("결과검색" 변경, 리셋)
          self.requestSearchData(
            value,
            force,
            $.extend(filterQueryData, filterDatas)
          );
        }
      },

      /**
       * 고객피드백 보내기
       * @param {string} value 라디오 버튼 value
       * @param {string} content 컨텐츠 value
       */
      requestFeedBack: function (value, content) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-feedback-url");
        var keyword = self.$inputSearch.val().trim().length >= 17 ? self.$inputSearch.val().trim() : self.$searchNotResultText.text().trim(); // 입력값 BTOCSITE-20493

        lgkorUI.showLoading();
        lgkorUI.requestAjaxData(
          ajaxUrl,
          {
            keyword: keyword,
            feedbackCode: value,
            feedbackDetail: content,
          },
          function (result) {
            $(window).trigger("toastshow", "피드백 보내기가 완료되었습니다.");
          }
        );
      },

      /**
       * 팝업 오픈 직후 발생 함수
       * @param {*} e
       * @param {*} data
       */
      openPopupComplete: function (e, data) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-search-unit-url");
        var $popup = $(e.target);
        var $select = $popup.find(".ui_selectbox");
        var model = data.model;
        var search2 = data.search2; // 소모품 전체보기 팝업 전용
        var title = data.title;
        var unit = $popup.data("unit") || "";

        // 닫기 시 앱 하단 복구
        $popup.one("modalhide", function (e) {
          self.modalUnitName = null;
          self.saveUIState(); // 팝업 닫힘 상태 저장
        });

        // 정렬 마크업 초기화
        $select.parent().hide();
        if (unit === "disposable") {
	        $select.html(
	          vcui.template(sortSelectTempate, { modal: true, unit: unit })
	        );
        }
        $select.vcSelectbox("update");

        $popup.css("overflow-y", "auto");
        //vcui.require(["search/modules/plpItem-VIO23"], function (PlpItem) {
          var plp = self.plpObj();

          var paramData = { search: model, force: false };
          if (search2) paramData.search2 = search2; // 소모품 전체보기 팝업 전용

          plp.init(
            { param: paramData },
            {
              container: data.href + " .morelist_wrap",
              moreUri: ajaxUrl,
              cartUri: self.$contentsSearch.attr("data-cart-url"), // [BTOCSITE-31159] 소모품 장바구니
              compatibleUri: self.$contentsSearch.attr("data-compatible-url"), //[BTOCSITE-40160] 소모품 호환모델 리스트 팝업 uri
              unit: unit,
              initialList: false,
            }
          );
          var filterData ={};
          var filterDatas ={};
          if(self.filterLayer){
        	// 특정 유닛 필터 정보
        	  filterData = self.filterLayer.getDataFromFilter({
                  unit: unit,
                });
        	  // 필터 데이터 string 형으로 가공
            filterDatas = self.makeJsonStrFilterData(
                filterData.unitFilterData
            );
          }

          var plpData = {
            sort: $select.val(),
            start: 1,
            end: 30, // 호출 전 총갯수 알수 없으므로 일단 목표치 30, callAjax() 에서 조정 됨
            filterData: filterDatas.filterData,
            smartFilter: filterDatas.smartFilter,
            count: 1, // 팝업열림과 동시에 30개 호출 하므로 +1
          };

          // 팝업 저장 데이터 존재 시 (팝업 내 리스트 클릭 후 상세에서 back했을 경우)
          var savedModalData;
          var savedData = lgkorUI.getStorage(self.uniqId);
          if (savedData.uiState) {
            var uiState = JSON.parse(savedData.uiState);

            if (uiState && uiState.hasOwnProperty("modal")) {
              if (uiState.modal.count) {
                var modal = (savedModalData = uiState.modal);

                plpData.end = 30 * modal.count;
                plpData.count = modal.count;
              }
            }
          }

          // 필터 상태 plp 객체에 업데이트
          plp.updateData(plpData);

          // ajax 호출
          plp.callAjax();

          var $plpCont = plp.getTarget();

          // 가로 스크롤 위치 저장
          var CHANGE_SCROLL_Y = plp.event.CHANGE_SCROLL_Y;
          $plpCont.off(CHANGE_SCROLL_Y).on(CHANGE_SCROLL_Y, function (e, data) {
            self.uiState.modal = data;
          });

          // 소모품 팝업에만 필요
          if (unit === "disposable") {
            // 정렬 셀렉트 박스 초기화
            var sortData = $select.val();
            $select.parent().show();
            $select.val(sortData).vcSelectbox("update");

            // 정렬 변경
            $select.off("change").on("change", function (e, data) {
              var target = $(e.currentTarget);
              var $plpCont = target
                .closest(".list-sorting")
                .next(".morelist_wrap");
              var plp = $plpCont.data("instance");

              // lgkorUI.showLoading();
              // 필터 상태 plp 객체에 업데이트
              plp.updateData({ sort: target.val() });

              // 셀렉트 박스 ui update
              $select.val(target.val()).vcSelectbox("update");

              // plp리스트 비움
              plp.clear();

              // ajax 호출
              plp.callAjax();
            });

            // 타이틀
            $popup.find(".prod_name").text(title);
          }

          // 카운트
          var $count = $popup.find(".list_count");
          $count.hide();

          var DONE = plp.event.DONE;
          $plpCont.one(DONE, function (e) {
            // 로딩이 완료되면 갯수 설정
            $count.text(vcui.number.addComma(plp.getTotalCount())).show();

            // 팝업 저장 데이터 존재 시 스클롤 복구
            if (savedModalData) {
              $popup.scrollTop(savedModalData.scrollY || 0);

              // restoreUIState() 에서 제거 유보시킨 uiState 정보 삭제
              delete savedData.uiState;
              lgkorUI.setStorage(self.uniqId, savedData);
            }

            // 팝업 열림 상태 저장
            self.modalUnitName = unit;
            self.saveUIState();
          });
        //});
      },

      /**
       * 레이어 초기화
       */
      setLayout: function () {
        var self = this;

        // 검색 레이어 닫기
        self.openSearchInputLayer(false);

        // 결과 없음 영역
        self.$searchNotResult.hide(); // 결과없음 메세지 영역
        self.$listNoData.hide(); // 검색 결과영역 속 nodata 영역

        // 고객 피드백 숨김
        self.$feedbackBoxWrap.hide();
        // BTOCSITE-23248 이메일 상담
        self.$emailConsultingWrap.hide();
        // 서비스 검색
        self.$resultService.hide();

        // 배너
		// [2024.02.13] 속도개선-jsp에서 처리
		// self.$resultBanner.children().hide();

        // AI
        self.$resultAI.hide();

        // 고객지원 컨텐츠
        self.$customerSupport.hide();
      },

      /**
       * 데이터 없음
       * @param {object} result ajax res
       */
      initNoData: function (result) {
        if (!result) return;

        var self = this;
        var data = result.data;
        var param = result.param;
        var inputValue = param.inputValue;
        var splitYN = param.splitYN;
        var searchedValue = param.search;

        // console.log("!!!!! nodata ::: " + inputValue);

        //BTOCSITE-48990 제로 키워드 페이지 > 네이버 검색 결과 제외 설정
        $('head').append('<meta name="robots" content="noindex">');

        // 필터없는 레이아웃 css 적용
        self.$searchResultWrap.addClass("no_filter");

        // 그룹핑 안되어 있어서 따로 숨김
		// 배너 하위는 제외
		// [2024.02.13] 속도개선-jsp에서 처리
		self.$searchResultWrap.find(".result-area:not('.result-banner')").children().hide();
		// [2024.02.13] 속도개선-리스트 숨김 처리 - ("이런제품 어떠세요?영역과 1:1문의 영역 사이 간격과 연관됨. 활성화시 간격 줄어듬.)
		self.$searchResultWrap.find(".result-list-wrap:not(.list-no-data)").hide();
		// 속도개선 - 결과 없음인 경우 영역 노출 및 비노출 처리  
		$('#displayCon').show();
		$('.nafilter_choice, .nafilter_anchor, .nafilter_tabs.ui_tab').hide();
		
        // 필터 영역 숨김
        self.$layFilter.hide();

        // 피드백 노출
        if (data.noData && data.noData["feedback"]) {
          self.$feedbackBoxWrap.show(); //BTOCSITE-23248 이메일 상담
          self.$emailConsultingWrap.show();

          self.$feedbackBoxWrap
            .find(".ui_radio_visible")
            .html(vcui.template(feedbackInputTemplate, data.noData));
        }

        // 메세지 태그 초기화
        self.$searchNotResult.show(); // nodata 컨테이너
        self.$searchNotNone.hide(); // 검색어를 입력해주세요
        self.$searchAgainMsg.hide(); // 다시 한번 확인해 주세요.
        self.$searchNotResultText.text(inputValue); // "" 결과를 찾으셨나요? 의 "" BTOCSITE-20493
        self.$searchNotSimilar.hide(); // "" 결과를 찾으셨나요?
        self.$searchNotSimilarA.hide(); // 결과로 이동

        // noData 에 대한 ajax 결과에 리스트 제공 시
        // 이런 제품 어떠세요?
        //vcui.require(["search/modules/plpItem-VIO23"], function (PlpItem) {
          
          var $listDIV = self.$listNoData.find(".result-list");
          var plp = self.plpObj();
		  
          // 신제품 외 모든 unit
          plp.init(result, {
            container: $listDIV.get(0),
            wishUri: self.$contentsSearch.attr("data-wish-url"),
            unit: "noData",
          });

          var $plpCont = plp.getTarget();
          var CHANGE_TAB = plp.event.CHANGE_TAB;
          $plpCont.off(CHANGE_TAB).on(CHANGE_TAB, function (e, data) {
            $.extend(self.uiState.product, data);
          });

          var CHANGE_PAGE = plp.event.CHANGE_PAGE;
          $plpCont.off(CHANGE_PAGE).on(CHANGE_PAGE, function (e, data) {
            $.extend(self.uiState.product.story, data);
          });

          self.$listNoData.show();
        //});

        // "" 검색결과가 없습니다.
        self.$searchNotResult
          .find(".word_area")
          .text(self.ellipsisValue(searchedValue));

        //"" 검색결과로 이동
        if (inputValue && inputValue != searchedValue) {
          var $shortenTxt_1 = inputValue.substring(0, 10);
          var $shortenTxt_2 = inputValue.substr(inputValue.length - 10, 10);

          // 일반
          if (splitYN != "Y") {
            // 다시 한번 확인해 주세요.
            self.$searchAgainMsg.hide();
            // "" 결과를 찾으셨나요?
            self.$searchNotSimilar.show();
            self.$searchNotResultText.text(inputValue);
            // 검색결과로 이동
            self.$searchNotSimilarA.attr("href", "#" + inputValue).show();

            if (inputValue.length >= 17) {
              self.$searchNotResultText.text(
                $shortenTxt_1 + " ~ " + $shortenTxt_2
              );
            }
          }
        } else {
          self.$searchAgainMsg.show();
          self.$searchNotSimilar.hide();
        }

        // 검색어 미입력 시 "검색어를 입력해주세요" 노출
        if (self.$inputSearch.val().trim() == "") {
          self.$searchAgainMsg.hide();
          self.$searchNotNone.show();
        }
      },

      /**
       * 연관 검색어 초기화
       * @param {*} data
       */
      initRelated: function (data) {
        var self = this;

        //연관 검색어 리스트 갱신
        var arr = data.related instanceof Array ? data.related : [];

        if (arr.length) {
          var $list_ul = self.$relatedKeywordList.find("ul");
          $list_ul.empty();

          arr.forEach(function (item, index) {
            $list_ul.append(
              vcui.template(relatedItemTemplate, { text: item.trim() })
            );
          });
        }

        self.$relatedKeywordList.toggle(arr.length > 0);
        self.$relatedKeywordList.removeClass("open");
      },

		/**
		 * 서비스 연결 유닛 초기화
		 * @param {Object} result
		 */
		initService: function (result) {
			var self = this;

			// console.log("!!!!! Service :::", result.data.service);

			self.$layFilter.hide();
			self.$searchResultWrap.hide();
			self.$resultService.show();

			var type = result.data.service.type;
			var $linkUnit = self.$resultService.find(".service_info");
			var $chatbotUnit = self.$resultService.find(".service_chatbot");

			$linkUnit.html(vcui.template(serviceTemplate, result.data.service));
			$linkUnit.parent().attr("class", "result_service " + type);

			// 챗봇이면
			if (type === "type4") {
				$linkUnit.hide();
				$chatbotUnit.show();

				//버튼 순서 변경
				var customer = $chatbotUnit.find(".chatbot_box > a.box_customer");
				$chatbotUnit.find(".chatbot_box .box_purchase").after(customer);
			} else {
				if(type === "type5" && result.data.service.imageUrl) {
					$linkUnit.find('span.icon').css('background-image', 'url("' + result.data.service.imageUrl +'")');
				}
				var purchase = $chatbotUnit.find(".chatbot_box > a.box_purchase");
				$chatbotUnit.find(".chatbot_box .box_customer").after(purchase);
			}
		},

      /**
       * 고객지원 컨텐츠 초기화
       * @param {Object} result
       */
      initSupportContent: function (result) {
        var self = this;
        var param = result.param;
        var searchedValue = param.search;

        var $customerSupport = self.$customerSupport;

        if (lgkorUI.stringToBool(result.data.supportContent)) {
          $customerSupport
            .show()
            .find(".cs_txt")
            .html("혹시 " + searchedValue + " 제품 사용에 문제가 있으신가요?");
        } else {
          $customerSupport.remove();
        }
      },

      /**
       * ai
       * @param {object} result
       */
      initAI: function (result) {
        var self = this;

        if (result.data && result.data.hasOwnProperty("ai")) {
          if (result.data.ai.title && result.data.ai.title.length) {
            /* var $unitWrap = self.$unitListWrap.filter(".support");
            var $title = $unitWrap.find(".sort-tit");

            // 문제해결 유닛 타이틀 변경
            if (!!$title.contents().length) {
              $title.contents().eq(0).get(0).textContent =
                "더욱 자세한 안내가 필요하세요?";

              $title.find("em").hide();
            } */

            // 문제해결 최상단으로 이동
            self.upperUnit("support");
            self.setUnitSort();

            // ai
            self.$resultAI
              .show()
              .html(vcui.template(aiTemplate, result.data.ai));
          }
        }
      },

      /**
       * 필터 초기화
       * @param {Object} result
       */
      initFilter: function (result) {
        var self = this;

        // 1회 생성
        if (!self.filterLayer) {
          self.filterLayer = new FilterLayer(
          self.$layFilter,
          self.$searchResultWrap,
          self.$aFilterTab,
          function (data) {
            // 재 검색
            self.requestReSearchData(data);
          },
          function (unitName) {
        	//[BTOCSITE-59848] 검색어 집계 세분화
        	var searchVal = self.$contentsSearch.attr("data-search-value").trim();
            self.sendKeyword(searchVal, "2", "1", unitName);
          }
        );

          // 유닛탭 클릭 시 발생하는 이벤트
          var event = self.filterLayer.event;
          self.$layFilter.on(event.CLICK_UNIT_TAB, function (e, unitName) {
            var $listWrap = $(".list-wrap").filter("." + unitName);
            var isFixed = self.$contWrap.hasClass("filter_fixed");
            var exH; // 예외 높이 (모바일도 px 이기때문에 수동으로.. css 높이에 따라 height() 계산하기엔 css 영향이 너무 큼)

            // 상단 fixed 유무와 device 에 따라 계산 ( height() 계산으로 받기 어려움 )
            if (isFixed) {
              exH = self.device === "pc" ? 0 : -113;
            } else {
              exH = self.device === "pc" ? 32 : -99;
            }

            // 모바일 탭 버튼 영역 없는 경우 높이 제외
            if (self.$layFilter.hasClass("hide-tab") && self.device !== "pc") {
              exH -= 59;
            }

            if (self.device === "mobile") {
              var aFilterHeight =
                self.$aFilterTab.outerHeight() +
                self.$aFilterTab.siblings(".nafilter_choice").outerHeight();
              exH += aFilterHeight;
            }

            // 전체보기 중인 유닛이 있다면 닫기
            self.deactivatedMore();

            if ($listWrap.length) {
              var st = $listWrap.offset().top - self.fixedAreaH - exH;

              self.moveScrollTop(st, unitName);
            }
          });
        }

        //FilterLayer 내부 생성자 require() 보다 빨라서 데이터만 저장하고 함수내 로직 진행 안함
        var savedFilterData = self.getSumSavedFilterData();
        self.filterLayer.create(result, savedFilterData);
        self.filterLayer.select(savedFilterData);

		// 필터 화면탭 초기 셋팅
		self.filterLayer.changeFilterTabFirstInfo();
      },

      /**
       * 리스트 영역 초기화
       * @param {Object} result
       */
      initList: function (result) {
        var self = this;

        //vcui.require(["search/modules/plpItem-VIO23"], function (PlpItem) {
          var units = [];
          // console.log("!!!!! initList", result);

			// 리스트를 그리기 위한 필터 "검색결과" 체크된 값 배열로 반환하기 위한 로직
			if (self.savedFilterData) {
				units = self.getUnitFilterList(self.savedFilterData);
			} else {
				// 저장데이터 없이 진입인 경우 filterLayer 에서 그려진 "검색결과" input 참조하여 unit 배열 유추
				var unitFilterData = self.filterLayer.getUnitFilterData();
				units = self.getUnitFilterList(unitFilterData);

				// 위에서 유추한 "검색결과" 내용 세션에 추가 저장, 재 진입 시 유지 위함
				self.setSessionStorage({
					filterData: self.makeStrFilterData(
						JSON.stringify(unitFilterData)
					),
				});
			}
			
				// [모바일인] A필터 노출
				if( self.device == "mobile" && $('.nafilter_anchor.mo-only .tabs li').length > 0 ) {
					self.$contWrap.find('.nafilter_anchor.mo-only').show();
				}

				// 성능개선으로 인한 화면 노출 처리
				if( self.device == "pc") {
					$('.result-banner.pc-only').show();
				}
					$(window).resize(function() {
					if($(window).width() > 768) {
						$('.result-banner.pc-only').show();
						}
					});

				// 프로모션 하단 영역 노출
				$('#displayCon').show();
			
          // "검색결과" 체크만큼 반복 실행
          units.forEach(function (unit) {
            // plp
            var plp = self.plpObj();

            // 신제품 외 모든 unit
            plp.init(result, {
              container: ".list-wrap." + unit + " .result-list:not(.ellarshow)", //[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
              moreUri: self.$contentsSearch.attr("data-search-unit-url"),
              wishUri: self.$contentsSearch.attr("data-wish-url"),
              cartUri: self.$contentsSearch.attr("data-cart-url"), // [BTOCSITE-31159] 소모품 장바구니
              compatibleUri: self.$contentsSearch.attr("data-compatible-url"), //[BTOCSITE-40160] 소모품 호환모델 리스트 팝업 uri
              moreFun: self.requestSearchMore.bind(self),
              unit: unit,
              sort: self.sortData[unit],
              isRentalFilter: self.getRentalFilterChecked(), //BTOCSITE-41977 렌탈 관련 필터 체크시 렌탈탭 디폴트 선택
              isSubspackageFilter: self.getSubspackageFilterChecked(), //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
              partnerType: self.$contentsSearch.attr("data-partner-type"),	//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
              partnerCd: self.$contentsSearch.attr("data-partner-cd"),		//[BTOCSITE-49598] B2B 복지몰(제휴사) 검색 구축
            });

            var $plpCont = plp.getTarget();

            if (unit === "product") {
              // 탭 변경 저장 이벤트
              var CHANGE_TAB = plp.event.CHANGE_TAB;
              $plpCont.off(CHANGE_TAB).on(CHANGE_TAB, function (e, data) {
                $.extend(self.uiState.product, data);
              });

              var CHANGE_PAGE = plp.event.CHANGE_PAGE;
              $plpCont.off(CHANGE_PAGE).on(CHANGE_PAGE, function (e, data) {
                $.extend(self.uiState.product.story, data);
              });
            }
//              if (unit === "subspackage") { //BTOCSITE-33608 LG UP 가전 2.0 구독	//[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
//                  // 탭 변경 저장 이벤트
//                  var CHANGE_TAB = plp.event.CHANGE_TAB;
//                  $plpCont.off(CHANGE_TAB).on(CHANGE_TAB, function (e, data) {
//                      $.extend(self.uiState.subspackage, data);
//                  });
//              }
            if (unit === "subscribe") {
                // 탭 변경 저장 이벤트
                var CHANGE_TAB = plp.event.CHANGE_TAB;
                $plpCont.off(CHANGE_TAB).on(CHANGE_TAB, function (e, data) {
                  $.extend(self.uiState.subscribe, data);
                });
              }
            if (unit === "event") {
              // 가로 스크롤 위치 저장
              var CHANGE_SCROLL_X = plp.event.CHANGE_SCROLL_X;
              $plpCont
                .off(CHANGE_SCROLL_X)
                .on(CHANGE_SCROLL_X, function (e, data) {
                  self.uiState.event = data;
                });
            }
            //[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
            if (unit === "video" && result.data.video.liveCommerce.data.length > 0) {
      		    $(".ellar-show-wrap").on(
        			  "click",
        			  ".ellarshow-area ul li a",
        			  function (e) {
        				  self.uiState.video.scrollX = $(".ellarshow").scrollLeft();

        				  var url = $.trim($(this).attr("data-href"));
        				  var host = $(location).attr('protocol') + "//" + $(location).attr('host');
        			      if(url) {
        			          if (isApp()) {
        			              if (vcui.detect.isIOS) {
        			                  var jsonString = JSON.stringify({
        			                      url: host+url,
        			                      command: "startLiveCommerce",
        			                  });
        			                  webkit.messageHandlers.callbackHandler.postMessage(jsonString);
        			              } else {
        			                  android.startLiveCommerce(host+url);
        			              }
        			          } else {
        			        	  window.sessionStorage.setItem("liveUrl", url);
        			              location.href = url;
        			          }
        			      }
        			  }
        		);
            }

            // plp wrap (노출 여부 포함)
            self.updateListWrap(plp);

            // 필터 스크롤 리프레쉬
            self.filterLayer.scrollHandler();
          });
			
         // [BTOCSITE-44448] LG전자 공식 유튜브 연동 - 동영상 유닛에만 필요 (엘라쇼)
          if (result.data.hasOwnProperty("video")) {
        	  if (result.data.video.liveCommerce.data.length > 0) {
        		  self.$searchResultWrap.find(".ellar-show-wrap").html(vcui.template(tempLiveCommerce, {liveCommerce: result.data.video.liveCommerce.data}));

        		  // [BTOCSITE-44448] LG전자 공식 유튜브 연동 - 엘라쇼 결과만 있을 경우
        		  if (result.data.video.count == 0) {
        			  $(".list-wrap.video").show();
        			  $(".list-wrap.video").find(".archive-wrap").hide();
        		  }
        	  }else {
        		  self.$searchResultWrap.find(".ellar-show-wrap").remove();
        	  }
          }

          self.initIntersection();
          self.initMoreIntersection();
          self.initAI(result); // ai 정답형
          self.checkPriorities(result);
          self.checkParams();
          self.restoreUIState();
          self.setCompares(); // "changeStorageData" 에서 대응하므로 주석처리 - BTOCSITE-23028: 대응 사라져 주석해제
          self.setWishs();
          self.srchTooltip();
          self.gallerySwiper();
          self.relatedSwiper();

		  // 렌지초기화 용으로 사용(추후 소스정리필요)
		  self.filterLayer.changeFilterTabFirstInfo();
		  
		  //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축 - 제품 탭 스크롤 적용
		  $('.ui_smooth_scrolltab').vcSmoothScrollTab('update');
        //});
      },

      /**
       * 전체보기 열기
       * @param {string} unitName 유닛명
       */
      moreList: function (unitName, data) {
        var self = this;
        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
        var $moreBtn = $listWrap.find(".result-allview:not('.fixed')"); // 전체보기 열기버튼
        var plp = $plpCont.data("instance");

        // 전체보기
        var sort = self.sortData[unitName];
        var pureListNum = $plpCont.find("> li").length;

        // 전체보기 중인 유닛이 있다면 닫기
        self.deactivatedMore();

        if (plp) {
          plp.updateData({ sort: sort });

          if (!data) {
            plp.more({ min: self.getUnitLimit(unitName) }); // limit 노출 갯수 전달. req start 값으로 사용
          } else {
            // more count 전달, plp.more() 내부 incrementPage()에서 +1 하므로 -1해서 전달
            plp.more($.extend({}, { min: pureListNum, count: data.count - 1 }));
          }
        }

        $moreBtn.hide().siblings(".fixed").show();
        $plpCont.addClass("more");

        self.checkReserveBanner(unitName);
      },

      /**
       * 전체보기 닫기
       * @param {string} unitName 유닛명
       */
      closeList: function (unitName) {
        var self = this;

        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
        var $closeBtn = $listWrap.find(".result-allview.fixed"); // 전체보기 닫기버튼
        var plp = $plpCont.data("instance");

        // 닫기
        if (plp) plp.close();

        $closeBtn.hide().siblings(".result-allview:not('.fixed')").show();
        $plpCont.removeClass("more");

        self.moreUnitName = null;

        self.checkReserveBanner(unitName);

        //전체보기 닫기 시 리스트 갯수 상태 저장
        self.saveUIState();
      },

      /**
       * doc 스크롤 이동
       * @param {number} st 스크롤 top
       * @param {string} unitName 유닛탭 클릭 시 toggleFilter 실행 위한 값 (intersection 규칙 피하기 위함)
       */
      moveScrollTop: function (st, unitName) {
        var self = this;
		var xtop = $( window ).width();
		var ytop = 0;
		
        self.scrollAction ++;

        // intersection 잠시 중단
        self.breakIntersection = true;

        // 스크롤 아래서 위로 올라오는 intersection 상태를 선행
        $(window).scrollTop(st + 1);

        $("html, body")
          .stop()
          .clearQueue()
          .animate(
            {
              scrollTop: st- ytop,
            },
            {
              queue: false,
              duration: 500, // 500 이상 권장 (isIntersecting 이 느리게 반응함)
              complete: function () {
                // html, body 중 1회만 하기 위한
                if ($(this).is("body")) {
                  self.breakIntersection = false;

                  self.filterLayer.toggleFilter(unitName);
                }
              },
            }
          );
      },

      /**
       * 화면상태 세션 저장 // 링크 이동 후 화면 상태 기억했다가 back했을 경우 복구하기 위함
       */
      saveUIState: function () {
        var self = this;

        self.setSessionStorage({
          uiState: JSON.stringify(self.getUIState()),
        });
      },

      /**
       * 화면 복구
       */
      restoreUIState: function () {
        var self = this;

        // 저장된 필터 ui 상태 전달
        var savedData = lgkorUI.getStorage(self.uniqId);

        if (savedData.uiState) {
          var uiState = JSON.parse(savedData.uiState);

          // console.log("!!!!! restore", self.uniqId, uiState);

          // 이전 상태가 전체보기 상태일때
          if (uiState.more && uiState.more.hasOwnProperty("unit")) {
            var unitName = uiState.more.unit;

            if (unitName) {
              var $listWrap = self.$unitListWrap.filter("." + unitName);
              var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
              var plp = $plpCont.data("instance");

              // moreList() > .. > requestReSearchData() > plpItem 의 callAjax() 에서 trigger
              if (plp) {
                var DONE = plp.event.DONE;
                $plpCont.one(DONE, function () {
                  self.moveScrollTop(uiState.doc.ypos); // 위치로 이동
                  self.restoreFilterLayer(uiState);
                  self.restorePlpItem(uiState);
                  self.setCompares();
                  self.setWishs();
                  self.srchTooltip();
                  self.gallerySwiper();
                  self.relatedSwiper();
                  self.setDataLayer();
                  $(".ellarshow").scrollLeft(uiState.video.scrollX);//[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
                });

                // 전체보기 상태로
                self.moreList(unitName, {
                  count: uiState.more.count,
                });
              }
            }
          } else {
            // 일반 상태
            self.moveScrollTop(uiState.doc.ypos); // 위치로 이동
            self.restoreFilterLayer(uiState);
            self.restorePlpItem(uiState);
            self.setCompares();
            self.setWishs();
            self.srchTooltip();
            self.gallerySwiper();
            self.relatedSwiper();
            self.setDataLayer();
            $(".ellarshow").scrollLeft(uiState.video.scrollX);//[BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
          }

          // 팝업 상태
          if (uiState.modal && uiState.modal.hasOwnProperty("unit")) {
            var modal = uiState.modal;

            if (modal && modal.hasOwnProperty("param")) {
              var openerBtn = $(
                'button[data-unit="' +
                  modal.unit +
                  '"][data-model="' +
                  modal.param.search +
                  '"]'
              );

              openerBtn.click(); // 팝업 열기 호출
            }
          } else {
            // ui 복구하면 기존 uiState 정보 삭제
            // 팝업 정보 있는 경우 위 if 통해 팝업 열리고 스크롤 복구 후 제거
            delete savedData.uiState;
            lgkorUI.setStorage(self.uniqId, savedData);
          }
        }
      },

      /**
       * filterLayer 상태 복구함수
       * @param {object} uiState savedData.uiState
       */
      restoreFilterLayer: function (uiState) {
        var self = this;

        if (!self.filterLayer) return;

        if (uiState.bfilter)
          self.filterLayer.setUIState("bfilter", uiState.bfilter);

        if (uiState.afilter)
          self.filterLayer.setUIState("afilter", uiState.afilter);

        self.filterLayer.restoreUIState();
      },

      /**
       * PlpItem 상태 복구함수
       * @param {object} uiState savedData.uiState
       */
      restorePlpItem: function (uiState) {
        var self = this;

        for (unitName in uiState) {
          var data = uiState[unitName];

          if (data) {
            var $listWrap = self.$unitListWrap.filter("." + unitName);
            var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
            var plp = $plpCont.data("instance");

            if (plp) {
              // 상태 복구
              plp.setRentalFilter(self.getRentalFilterChecked()); //BTOCSITE-41977 렌탈 관련 필터 체크시 렌탈탭 디폴트 선택
              plp.setSubspackageFilter(self.getSubspackageFilterChecked()); //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
              plp.restore(data);

              if (unitName === "product") {
                // 마지막 활성화한 제품 내 스토리 탭 컨텐츠 복구
                plp.restoreStoryLivelg(data.story);
              }
              if (unitName === "gallery") {
                  // 선택 포커스 상품 선택
                  plp.restoreGallery(data);
              }
              //갤러리 일때
            }
          }
        }
      },

      /**
       * 필터 재정의
       * @param {object} data 검색 결과
       */
      updateFilter: function (data) {
        var self = this;
        var unitName = data.unit;

        // 필터 교체
        var resultData = self.filterLayer.getResultData() || { data: null }; // 필터레이어가 담고있는 ajax 결과 데이터
        var unitResultData = data.res || {}; // 재검색 결과
        var filterLayerUnitData = resultData.data[unitName]; // 필터레이어 객체 유닛별 필터 데이터

        // ajax 결과 데이터 특정 유닛 필터 정보 교체
        if (filterLayerUnitData.filterList && unitResultData.filterList) {
          filterLayerUnitData.filterList = unitResultData.filterList;
        }

        if (unitResultData.smartFilterList) {
          filterLayerUnitData.smartFilterList = unitResultData.smartFilterList;
        }

        // var unitData = {};
        // unitData[unitName] = unitResultData; // {product: {data: {}, filterList:{}, .. }}
        // console.log(self.filterLayer.makeFilterData(unitData));

        var savedFilterData = self.getSumSavedFilterData();
        self.filterLayer.create(resultData, savedFilterData);
        self.filterLayer.select(savedFilterData);

        self.initIntersection();
      },

      /**
       * 유닛별 리스트 재정의
       * @param {object} data 검색 결과
       */
      updateList: function (data) {
        var self = this;
        var unitName = data.unit;

        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
        var plp = $plpCont.data("instance");

        // 리스트 교체
        if (plp) {
          plp.setRentalFilter(self.getRentalFilterChecked()); //BTOCSITE-41977 렌탈 관련 필터 체크시 렌탈탭 디폴트 선택
          plp.setSubspackageFilter(self.getSubspackageFilterChecked()); //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
          plp.changeList(data.res);
          self.updateListWrap(plp);
        }
      },

      /**
       * 리스트 그룹 상태 변경
       * @param {PlpItem} plp plp instance
       */
      updateListWrap: function (plp) {
        var self = this;
        var totalCount = plp.getTotalCount() || 0;
        var $plpCont = plp.getTarget();
        var $listWrap = $plpCont.closest(".list-wrap");
        var $reserveBanner = $plpCont.nextAll("div[class$='-banner']");
        var unitName = plp.getUnit();
        var unitNameKor = plp.getUnitNameKor();
        var checkFilterWrap = self.$contWrap.find(".check-filter-wrap"); // 내일배송 ,임직원가
        var tomorrowCheckbox = self.$contWrap.find(".tomorrow_checkbox");
        var employeeCheckbox = self.$contWrap.find(".executive_checkbox");
        var multiItemCheckbox = self.$contWrap.find(".multi_product_checkbox");	//BTOCSITE-48682 다품목할인
        var isTomorrow = false; // 내일 배송
        var isEmployee = false; // 임직원 할인
        var isMultiItem = false; //BTOCSITE-48682 다품목할인

        // 제품 유닛에만 필요
        if (unitName === "product") {

          // 내일배송 노출 유무
          isTomorrow = !!self.filterLayer.getFilterInput(
            "product",
            "producttype",
            "tomorrow"
          ).length;
          //BTOCSITE-48682 다품목할인 노출 유무
          isMultiItem = !!self.filterLayer.getFilterInput(
            "product",
            "producttype",
            "multiItem"
          ).length;
          // 임직원 할인 노출 유무
          isEmployee = !!self.filterLayer.getFilterInput(
            "product",
            "producttype",
            "employee"
          ).length;
          // 임직원 여부 체크
          if ( $(".btn-emp").is(':visible') == false ){
        	  isEmployee =false;
          }

          if(isEmployee || isTomorrow){
         	 checkFilterWrap.addClass("active");
          }else{
         	 checkFilterWrap.removeClass('active');
          }
          //BTOCSITE-32032 내일 배송 확대
          if(isTomorrow){
          	tomorrowCheckbox.show();
              tomorrowCheckbox.html(
  	            vcui.template(topTomorrowTemplate, {
  	              title: plp.getUnitNameKor(),
  	              unit: unitName,
  	              modal: false,
  	              tomorrow: { show: isTomorrow, checked: self.getTomorrowChecked() }
  	            })
  	          );
          }else{
          	 tomorrowCheckbox.hide();
          }

          //BTOCSITE-48682 검색 > 다품목할인 필터 기능 추가
          if(isMultiItem){
        	multiItemCheckbox.show();
        	multiItemCheckbox.html(
	            vcui.template(topMultiItemTemplate, {
	              title: plp.getUnitNameKor(),
	              unit: unitName,
	              modal: false,
	              multiItem: { show: isMultiItem, checked: self.getMultiItemChecked() }
	            })
	          );
          }else{
        	 multiItemCheckbox.hide();
          }

          //BTOCSITE-37747 검색 > 임직원 필터 기능 추가
          if(isEmployee){
        	employeeCheckbox.show();
            employeeCheckbox.html(
	            vcui.template(topEmployeeTemplate, {
	              title: plp.getUnitNameKor(),
	              unit: unitName,
	              modal: false,
	              employee: { show: isEmployee, checked: self.getEmployeeChecked() }
	            })
	          );
          }else{
        	 employeeCheckbox.hide();
          }


        }

        // wrap markup
        $listWrap.find(".list-sorting").html(
          vcui.template(unitTitleTemplate, {
            title: plp.getUnitNameKor(),
            unit: unitName,
            modal: false,
            tomorrow: { show: isTomorrow, checked: self.getTomorrowChecked() },
           /* employee: { show: isEmployee, checked: self.getEmployeeChecked() },*/
            multiItem: { show: isMultiItem, checked: self.getMultiItemChecked() },	//BTOCSITE-48682 다품목할인
          })
        );

        // 전체보기/닫기 버튼 markup
        $listWrap.find(".result-allview_area").html(
          vcui.template(moreTemplate, {
            unitName: unitNameKor,
            notAllBtn: $plpCont.hasClass("boxarea"),
            count: vcui.number.addComma(totalCount),
          })
        );

        // 전체 데이터 기준 전체보기 버튼 토글
        $listWrap
          .find(".result-allview_area")
          .toggle(totalCount > self.getUnitLimit(unitName));

        // 해당 unit list wrap 토글
        $listWrap.toggle(totalCount > 0);

        // 셀렉트 박스
        var selectbox = $listWrap.find(".ui_selectbox").data("ui_selectbox");
        if (selectbox) {
          // 셀렉트 박스 sortData 데이터 있으면 적용
          selectbox.value(self.sortData[unitName], false);
        } else {
          // 셀렉트 박스 초기화
          $listWrap
            .find(".ui_selectbox")
            .val(self.sortData[unitName])
            .vcSelectbox();
        }

        // 필터 제품 정렬 데이터 동기화
        if(unitName === 'product') {
        	$("input[name=filterSort]").filter('input[value='+self.sortData[unitName]+']').attr("checked", "checked");
        }

        // 예약 유도 버튼 토글 체크
        self.checkReserveBanner(unitName);
        // 예약 유도 버튼 무한 스크롤 이후 이벤트 리스너
        var IS_LAST = plp.event.IS_LAST;
        $plpCont.off(IS_LAST).on(IS_LAST, function (e, unitName) {
          self.checkReserveBanner(unitName);
        });
      },

      /**
       * 유닛 최상단으로
       * @param {} unitName
       */
      upperUnit: function (unitName) {
        var self = this;

        // 문제해결 유닛 리스트 최상단으로 위치 변경
        self.$unitListWrap
          .parent()
          .prepend(self.$unitListWrap.filter("." + unitName));

        // 순서변경에 대한 selector 재정의
        self.$unitListWrap = self.$searchResultWrap.find(
          ".result-list-wrap:not(.list-no-data) > .list-wrap"
        );

        // [BTOCSITE-45540] [탐색고도화] > [mo] 필터 탭 정보 노출
        self.filterLayer.changeFilterTabInfo();
      },

      /**
       * 전체보기 닫기 버튼 토글 (intersection 용, 부모 elm은 click에 의해 display 조작 중)
       * @param {string} unitName 유닛명
       */
      activateMoreBtnA: function (unitName) {
        var self = this;

        self.$unitListWrap.find(".result-allview.fixed").addClass("outside");

        if (unitName) {
          self.$unitListWrap
            .filter("." + unitName)
            .find(".result-allview.fixed")
            .removeClass("outside");
        }
      },

      /**
       * 활성화된 전체보기 닫기버튼 click 발생시켜 닫기
       */
      deactivatedMore: function () {
        var self = this;

        var visibleCloseMoreBtn = self.$unitListWrap
          .find(".result-allview.fixed > a")
          .not(":hidden");

        visibleCloseMoreBtn.click();
      },

      /**
       * intersection observer 초기화 (유닛별 토글링 기능)
       */
      initIntersection: function () {
        var self = this;
        var topH = self.fixedAreaH + 1; // 유닛 탭 클릭할 때 스크롤 아래서 위로 올라오는 효과를 위해 +1 추가
        var winH = vcui.dom.getWinHeight();

        // 대상
        var $listWrap = self.$unitListWrap.not(":hidden");

        if (!$listWrap.length) return; // breakpoint 최초 실행에서 아직 리스트 로드 전이므로 진행 안함

        // 제거
        self.destroyIntersection();

        //
        self.intersection = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entrie) {
					var target = entrie.target;
					var inter = entrie.isIntersecting;
					var ypos = target.getBoundingClientRect().top;
					var height = target.getBoundingClientRect().height;
					var unitName;

					if (target && target.classList.length >= 2) {	//[BTOCSITE-44448] LG전자 공식 유튜브 연동
						unitName = target.classList.item(1);
					}
					if (self.filterLayer && self.filterLayer.loaded) {
						if (self.breakIntersection) return;

						if (self.scrollDirection === "up") {
							if (inter && (ypos <= topH)) {
								self.filterLayer.toggleFilter(unitName);
							}

							if ( !inter && ypos > topH && !$(target).prevAll().not(":hidden").length ) { // 이전 element 노출된게 없으면
								//console.log("first");
								self.filterLayer.toggleFilter(unitName); // 첫번째 유지
							}
						} else if (self.scrollDirection === "down") {
							if (inter && ((ypos + height) >= window.innerHeight)) {
								self.filterLayer.toggleFilter(unitName);
							}

							if (!inter && ((ypos + height) < (window.innerHeight)) && !target.nextElementSibling ) {
								//console.log("last");
								self.filterLayer.toggleFilter(unitName); // 마지막 유지
							}
						}
					}
				});
			},
			{
			threshold: [0],
			rootMargin:
				self.scrollDirection === "down"
					? "-" + winH + "px 0px 0px 0px"
					: "-" + topH + "px 0px -" + (winH - topH) + "px 0px",
			}
		);

        // init observe
        $listWrap.each(function (idx, elm) {
        	  self.searchTimer = setTimeout(function () {
        		  self.intersection.observe(elm);
              }, 1);

        });
      },

      /**
       * intersection observer 제거
       */
      destroyIntersection: function () {
        var self = this;

        if (self.intersection) {
          self.intersection.disconnect();
          self.intersection = null;
        }
      },

      /**
       * more intersection observer 초기화 (유닛별 토글링 기능)
       */
      initMoreIntersection: function () {
        var self = this;
        var winH = vcui.dom.getWinHeight();

        // 대상
        var $listWrap = self.$unitListWrap.not(":hidden");

        if (!$listWrap.length) return; // breakpoint 최초 실행에서 아직 리스트 로드 전이므로 진행 안함

        // 제거
        self.destroyMoreIntersection();

        //
        self.moreIntersection = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entrie) {
              var target = entrie.target;
              var inter = entrie.isIntersecting;
              var ypos = target.getBoundingClientRect().top;
              var unitName;

              if (target && target.classList.length >= 2) {	//[BTOCSITE-44448] LG전자 공식 유튜브 연동
                unitName = target.classList.item(1);
              }

              if (inter) {
                if (ypos < winH) {
                  self.activateMoreBtnA(unitName);
                }
              } else {
                if (!target.previousElementSibling && ypos > winH) {
                  // console.log("first");
                  self.activateMoreBtnA();
                } else if (!target.nextElementSibling && ypos < winH) {
                  // console.log("last");
                  self.activateMoreBtnA();
                }
              }
            });
          },
          {
            threshold: [0],
            rootMargin: "-" + winH + "px 0px 0px 0px",
          }
        );

        // init observe
        $listWrap.each(function (idx, elm) {
          self.moreIntersection.observe(elm);
        });
      },

      /**
       * more intersection observer 제거
       */
      destroyMoreIntersection: function () {
        if (self.moreIntersection) {
          self.moreIntersection.disconnect();
          self.moreIntersection = null;
        }
      },

      /**
       * 어드민 unit 우선순위 설정
       * @param {Object} result 검색 결과 데이터
       */
      checkPriorities: function (result) {
        var self = this;

        if (result.data) {
          if (result.data.hasOwnProperty("priorities")) {
            var priorities = result.data.priorities || [];
            priorities.reverse().forEach(function (unit) {
              self.upperUnit(unit);
            });
            if (!!priorities.length) self.setUnitSort();
          }
        }
      },

      /**
       * 화면에 영향주는 url 파라미터 체크
       */
      checkParams: function () {
        var self = this;

        if (lgkorUI.getParameterByName("unit")) {
          var unitName = lgkorUI.getParameterByName("unit");

          // 스크롤 이동 대신 최상단으로
          self.upperUnit(unitName);
          self.setUnitSort();
        }
      },

      /**
       * 예약 유도 버튼 그룹 배너 활성화 유무 체크
       * @param {string} unitName 유닛명
       */
      checkReserveBanner: function (unitName) {
        var self = this;
        if (!(unitName == "gallery" || unitName == "video") ){	//[BTOCSITE-44448] LG전자 공식 유튜브 연동	//[BTOCSITE-56993] UP가전 2.0 제품_검색 구축

            var $plpCont = self.$unitListWrap
              .filter("." + unitName)
              .find("> .result-list");
            var $reserveBanner = $plpCont.nextAll("div[class$='-banner']");
            var plp = $plpCont.data("instance");
            var totalCount = plp.getTotalCount() || 0;
            var listNum = $plpCont.find("> li").length;

            // 매장/상담 배너면 무조건 노출
            // 문제해결 배너면 맨 마지막 페이지에만 노출
            var isShop = $reserveBanner.hasClass("shopservice-banner");
            $reserveBanner.toggle(totalCount <= listNum || isShop);

            // 매장/상담 인 경우
            if (unitName === "shop") {
              // 센터/매장 에서 매장이 0 게이면 "매장 상담 예약" 숨김
              var isServiceCenterAll = !$plpCont.find(".item.shop").not(".center")
                .length;

              $reserveBanner
                .find(".service.advice")
                .parent()
                .toggle(!isServiceCenterAll);
            }
        }
      },

      /**
       * unit 필터 배열로 반환
       * @param {object} data {unit: {검색결과: ["product","support"], ...
       * @returns {array} ["product", "support"]
       */
      getUnitFilterList: function (data) {
        var unit = data.unit || {};
        var unitArr = [];

        for (key in unit) {
          unitArr = unit[key];
        }

        return unitArr;
      },

      /**
       * 필터 데이터 합쳐 반환 ( FilterLayer 의 .create() .select() 인자로 사용 )
       * @return {object} {product:{filterData:{제품타입:["공기청정기"]},smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
       */
      getSumSavedFilterData: function () {
        var self = this;

        // FilterLayer 에서 활용을 위해 유닛명 아래 filterData : {} 로 한번 감쌈
        var filterData = {};
        if (self.savedFilterData) {
          for (unit in self.savedFilterData) {
            var data = $.extend({}, self.savedFilterData[unit]);
            filterData[unit] = { filterData: data };
          }
        }

        // FilterLayer 에서 활용을 위해 유닛명 아래 smartFilter : {} 로 한번 감쌈
        var smartFilter = {};
        if (self.savedSmartFilterData) {
          for (unit in self.savedSmartFilterData) {
            var data = $.extend({}, self.savedSmartFilterData[unit]);
            smartFilter[unit] = { smartFilter: data };
          }
        }

        var filters = $.extend({}, filterData, smartFilter);

        var sumData = {};
        for (key in filters) {
          sumData[key] = $.extend(
            {},
            filterData[key] || {},
            smartFilter[key] || {}
          );
        }

        return sumData;
      },

      /**
       * 모든 정렬 데이터 반환
       * @returns
       */
      getSortValues: function () {
        var self = this;

        var units = [];

        if (self.filterLayer) {
          units =
            self.getUnitFilterList(self.filterLayer.getUnitFilterData()) || [];
        } else {
          self.$unitListWrap.each(function () {
            units.push(this.classList.item(this.classList.length - 1));
          });
        }

        units = units.filter(function (unitName) {
          return unitName !== "new";
        });

        return units.reduce(function (obj, unitName) {
          obj[unitName] = self.$unitListWrap.filter("." + unitName).find(".ui_selectbox").val() ||   "best";
          return obj;
        }, {});
      },

      /**
       * 내일배송 선택 유무 반환
       */
      getTomorrowChecked: function () {
        var self = this;
        var returnValue = false;

        if (self.savedFilterData) {
          if (
            self.savedFilterData.product &&
            self.savedFilterData.product.hasOwnProperty("producttype")
          ) {
            returnValue =
              self.savedFilterData.product.producttype.indexOf("tomorrow") > -1;
          }
        }

        return returnValue;
      },
      /**
       * BTOCSITE-48682 다품목할인 선택 유무 반환
       */
      getMultiItemChecked: function () {
        var self = this;
        var returnValue = false;

        if (self.savedFilterData) {
          if (
            self.savedFilterData.product &&
            self.savedFilterData.product.hasOwnProperty("producttype")
          ) {
            returnValue =
              self.savedFilterData.product.producttype.indexOf("multiItem") > -1;
          }
        }

        return returnValue;
      },
      /**
       * 임직원 제품 선택 유무 반환
       */
      getEmployeeChecked: function () {
        var self = this;
        var returnValue = false;

        if (self.savedFilterData) {
          if (
            self.savedFilterData.product &&
            self.savedFilterData.product.hasOwnProperty("producttype")
          ) {
            returnValue =
              self.savedFilterData.product.producttype.indexOf("employee") > -1;
          }
        }

        return returnValue;
      },
      /**
       * 제품 렌탈 관련 필터 적용 여부 반환
       * BTOCSITE-41977 렌탈 관련 필터 체크시 렌탈탭 디폴트 선택
       */
      getRentalFilterChecked: function () {
          var self = this;
          var returnValue = false;

          if (self.savedFilterData) {
            if (
              self.savedFilterData.product &&
              self.savedFilterData.product.hasOwnProperty("producttype")
            ) {
              returnValue =
                self.savedFilterData.product.producttype.indexOf("rental") > -1;
            }
            if (
			  self.savedFilterData.product &&
			  self.savedFilterData.product.hasOwnProperty("rentalprice")
			) {
			  returnValue = true;
			}
            if (
      		  self.savedSmartFilterData.product &&
      		  self.savedSmartFilterData.product.hasOwnProperty("가전구독가격")
      		) {
      		  returnValue = true;
      		}
          }
          return returnValue;
      },
      
      //[BTOCSITE-56993] UP가전 2.0 제품_검색 구축
      getSubspackageFilterChecked: function () {
          var self = this;
          var returnValue = false;

          if (self.savedFilterData) {
            if (
			  self.savedFilterData.product &&
			  self.savedFilterData.product.hasOwnProperty("subspackageprice")
			) {
			  returnValue = true;
			}
          }
          
          if (self.savedSmartFilterData) {
            if (
    		  self.savedSmartFilterData.product &&
    		  self.savedSmartFilterData.product.hasOwnProperty("subspackageprice")
    		) {
    		  returnValue = true;
    		}
          }
          return returnValue;
      },      

      /**
       * 유닛 노출 갯수 반환
       * @param {string} unitName 유닛명
       * @returns
       */
      getUnitLimit: function (unitName) {
        var num = 5;

        switch (unitName) {
			case "product": num = 10; break;
			case "event"  : num = 3;  break;
			case "shop"   : num = 10; break;
			case "gallery": num = 6;  break; // BTOCSITE-21785 갤러리
			case "story"  : num = 4;  break; // [BTOCSITE-37460] 스토리 유닛 UI개선
			case "video"  :	num = 4;  break; // [BTOCSITE-44448] LG전자 공식 유튜브 연동
          default:
        }

        return num;
      },

      /**
       * 화면상태 정보 반환
       * @returns
       */
      getUIState: function () {
        var self = this;
        var moreInfo = {};
        var modalInfo = {};

        // 전체보기 싱테
        if (self.moreUnitName) {
          var $listWrap = self.$unitListWrap.filter("." + self.moreUnitName);
          var $plpCont = $listWrap.find("ul.result-list:not(.ellarshow)");	// [BTOCSITE-44448] LG전자 공식 유튜브 연동 [BTOCSITE-47951] 엘라쇼 히스토리 백 및 앵커링
          var plp = $plpCont.data("instance");

          if (plp) {
            var plpPageInfo = plp.getPageInfo();

            moreInfo = {
              unit: plp.getUnit(),
              count: plpPageInfo.count,
            };
          }
        }

        // 팝업 상태
        if (self.modalUnitName) {
          var $listWrap = $(
            '.morelist-layer[data-unit="' + self.modalUnitName + '"]'
          );
          var $plpCont = $listWrap.find(".morelist_wrap");
          var plp = $plpCont.data("instance");

          if (plp) {
            var plpPageInfo = plp.getPageInfo();

            modalInfo = {
              scrollY: self.uiState.modal.scrollY || 0,
              unit: plp.getUnit(),
              count: plpPageInfo.count,
              param: plp.getParam(),
            };
          }
        }

        // 필터 영역 상태
        var filterUIState ;
        if(self.filterLayer){
        	filterUIState = self.filterLayer.getUIState();
        }

        // 묶어 반환
        return $.extend({}, self.uiState, filterUIState, {
          more: moreInfo,
          modal: modalInfo,
        });
      },

      /**
       * ajax req 불필요한 데이터 제거
       * @param {object} data
       * @returns
       */
      makePayloadData: function (data) {
        // 스마트 필터 비어있으면 ajax 넘기지 않기 (개발 요청)
        if (data.smartFilter) {
          var smartFilter = JSON.parse(data.smartFilter);
          if (!Object.keys(smartFilter).length) {
            delete data.smartFilter;
          }
        }

        // uiState 제거
        if (data.uiState) {
          delete data.uiState;
        }

        return data;
      },

      /**
       * json 형태 string 필터 데이터 반환
       * @param {*} data
       * @returns
       */
      makeJsonStrFilterData: function (data) {
        var self = this;

        return {
          filterData: JSON.stringify(
            JSON.parse(
              self.makeStrFilterData(JSON.stringify(data.filterData || {}))
            )
          ),
          smartFilter: JSON.stringify(
            JSON.parse(
              self.makeStrFilterData(JSON.stringify(data.smartFilter || {}))
            )
          ),
        };
      },

      /**
       * 필터 string 데이터 세션 저장용으로 변경
       * @param {string} str '{"unit":{"검색결과":["new","product"], ...
       * @returns {string} '{"unit":{"검색결과":"new||product", ...
       */
      makeStrFilterData: function (str) {
        var data = JSON.parse(str || "{}");

        for (key in data) {
          var unit = data[key];

          if ($.isPlainObject(unit)) {
            // 유닛명 있는 경우 (전체 검색에 사용)
            for (key in unit) {
              unit[key] = unit[key].join("||");
            }
          } else {
            // 특정 유닛 검색에 사용
            // {"검색결과":["new","product"] >> {"검색결과":"new||product"
            data[key] = data[key].join("||");
          }
        }

        return JSON.stringify(data);
      },

      /**
       * 필터 string 데이터 배열용으로 변경
       * @param {string} str '{"unit":{"검색결과":"new||product"},"product":{"제품타입":"공기청정기"}}, ...
       * @returns {string} '{"unit":{"검색결과":["new","product"]},"product":{"제품타입":["공기청정기"]}}, ...
       */
      makeArrFilterData: function (str) {
        var data = JSON.parse(str || "{}");

        for (key in data) {
          var unit = data[key];

          for (key in unit) {
            unit[key] = unit[key].split("||");
          }
        }

        return JSON.stringify(data);
      },

      // setter
      /**
       * 필터 데이터 저장
       * @param {object} data {product:{filterData:{제품타입:["공기청정기"]}}, ...
       * @param {object} smart {product:{smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
       */
      setSavedFilterData: function (data, smart) {
        var self = this;

        if (data) {
          if (typeof data === "string") data = JSON.parse(data);

          self.savedFilterData = data;
        }

        if (smart) {
          if (typeof smart === "string") smart = JSON.parse(smart);

          self.savedSmartFilterData = smart;
        }
      },

      /**
       * 검색 정보 세션 스토리지 저장
       * @param {object} data
       */
      setSessionStorage: function (data) {
        var self = this;

        if (self.uniqId) {
          var savedData = lgkorUI.getStorage(self.uniqId);

          if (savedData) {
            lgkorUI.setStorage(self.uniqId, $.extend({}, savedData, data));
          } else {
            lgkorUI.setStorage(self.uniqId, data);
          }
        }
      },

      /**
       * 노출 유닛 리스트 순서 저장
       * @param {boolean} initialize true 시 고객지원 컨텐츠 display 조작 하지 않음 (self.unitSort 초기화용)
       */
      setUnitSort: function (initialize) {
        var self = this;

        var unitName;
        var arr = [];
        self.$unitListWrap.each(function () {
          unitName = $(this).attr("class").split(" ").pop();
          arr.push(unitName);
        });

        self.unitSort = arr;

        if (!initialize) {
          // 문제해결 유닛이 최상단이면 고객지원 컨텐츠 숨김
          self.$customerSupport.toggle(
            self.unitSort.length > 0 && self.unitSort[0] !== "support"
          );
        }
      },

      /**
       * 비교하기 버튼 활성화 변경
       */
      setCompares: function () {
        var self = this;
        var productLI = self.$listProduct // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상
          .filter(".product")
          .find(".item")
          .closest("li");
        var compareInput = productLI.find(".compare_check input[data-id]");
        compareInput.prop("checked", false);

        var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY);

        for (category in storageCompare) {
          var compareData = storageCompare[category];
          compareData["data"].forEach(function (data) {
            var modelID = data["id"]; // md

            compareInput = productLI.find(
              ".compare_check input[data-id=" + modelID + "]"
            );
            compareInput.prop("checked", true);
          });
        }
      },

			/**
			 * 찜하기 버튼 활성화 변경
			*/
			setWishs: function () {
				var self = this;
				var ajaxUrl = self.$contentsSearch.attr("data-wish-url");

				if (ajaxUrl) lgkorUI.checkWishItem(ajaxUrl);
			},

			/**
			 * ga
			*/
			setDataLayer: function () {
				if (typeof dataLayer !== "undefined" && dataLayer) {
					dataLayer.push({ event: "searchResultOpen" });
				}
			},

			/**
			 * 내일배송 툴팁
			*/
			srchTooltip: function() {
				var tooltip = $('.srch-tooltip');
				tooltip.each(function() {
					var _t = $(this);
					var btn = _t.children('button');
					var btnClose = _t.children('.tooltip-box').children('.btn-close');
					btn.attr({'aria-haspopup': true, 'aria-expanded': false}).siblings('.tooltip-box').attr({'aria-hidden': true});
					btn.on('click', function(e) {
						e.preventDefault();
						var _b = $(this);
						_b.attr({'aria-expanded': true}).siblings('.tooltip-box').attr({'aria-hidden': false});
						_b.siblings('.tooltip-box').addClass('active');
					});

					btnClose.on('click', function(e) {
						e.preventDefault();
						var _close = $(this);
						_close.parent().removeClass('active').attr({'aria-hidden': true});
					});
				});
			},

			/**
			 * 갤러리 Swiper
			 */
			gallerySwiper: function() {
				//갤러리   [BTOCSITE-21785]
				if($(".gallery-swiper").length > 0 ){
					var gallery_swiper = new Swiper(".gallery-swiper", {
						observer: true,
						observeParents: true,
						watchSlidesProgress: true,
						pagination: {
							el: ".gallery-swiper .swiper-pagination",
						},
						navigation: {
							nextEl: ".swiper-button-next.gallery-next",
							prevEl: ".swiper-button-prev.gallery-prev",
						},
						breakpoints: {
							1025 : {
								spaceBetween: 24,
								slidesPerView: 3,
							},
							280 :{
								spaceBetween: 14,
								slidesPerView: 1,
								spaceBetween: 8.5,
								slidesPerView: 3,
							}
						}
					});
				}
			},

			/**
			 * 연관 추천 제품 Swiper
			 */
			relatedSwiper: function() {
				// 연관 추천 제품
				if($(".related-swiper").length > 0) {
					new Swiper(".related-swiper", {
						slidesPerView: 'auto',
						spaceBetween: 8,
						resistance: true,
						resistanceRatio: 0,
						observer: true,
						observeParents: true,
						breakpoints: {
							768 : {
								spaceBetween: 12,
							},
						}
					});
				}
			},

			// 모바일 상단 프로모션 영역 타이틀 높이조절
			promotionBannerHeight: function() {
				var banner = $('.result-banner.mo-only').find('.bnr_area.type02');
				banner.each(function() {
					var _this = $(this);
					if(_this.hasClass('nor') || _this.hasClass('time-deal')) {
						var rightBanner = _this.children('.bnr_right');
						var empty = 26;
						var leftBnHeight = rightBanner.children('a:first-child').find('.bnr_pay').outerHeight() + empty || 0;
						var rightBnHeight = rightBanner.children('a:last-child').find('.bnr_pay').outerHeight() + empty || 0;
						var maxHeight;
						if(leftBnHeight < rightBnHeight) {
							maxHeight = rightBnHeight
						} else {
							maxHeight = leftBnHeight;
						}
						rightBanner.css({height: maxHeight});
					}
				});
			}

		};
		search.init();

	});

	//BTOCSITE-39423 뒤로가기시 isIOS 스크립트 호출 안되는경우 처리
	$(window).on('pageshow',function(e){
		if(e.originalEvent ){
			if(  e.originalEvent.persisted && vcui.detect.isIOS) {
				search.init();
			}
		}
	});

	// 검색 스크롤 이벤트
	$(window).on('scroll',function(){
		var _this = $(this);
		var winW = _this.width();
		var mobW = 767;
		var nowScr = _this.scrollTop();
		var nafilterChoice = $('.nafilter_choice');
		var nafilterChoiceOffsetT = parseInt(nafilterChoice.offset().top);
		var nafilterChoiceTop = parseInt(nafilterChoice.css('top'));
		var keywordWrap = $('.contents.search').children('.input-keyword-wrap');
		var keywordOffsetT = parseInt(keywordWrap.offset().top);
		var contWrap = $('.cont-wrap');
		var filterWrap = $('#filterWrap');
		var footerHeight = $('footer').outerHeight();

    // BTOCSITE-56703
    var scTop = $(document).scrollTop(); 
    var closeAllviewBtn = $('.result-allview.fixed'); // 전체보기닫기 버튼
    var resultListSections = closeAllviewBtn.parent().parent('.list-wrap'); // 리스트 영역

    // BTOCSITE-56703

		if (winW > mobW) {
			if (nowScr >= keywordOffsetT) {
				keywordWrap.addClass('scroll');
				_this.scrollTop(nowScr);
			} else {
				keywordWrap.removeClass('scroll');
			}

			if(nowScr >= contWrap.offset().top - keywordWrap.outerHeight()) {
				contWrap.addClass('fixed');
			} else {
				contWrap.removeClass('fixed');
			}

			if(nowScr >= $(document).height() - _this.height() - footerHeight) {
				contWrap.addClass('btm');
			} else {
				contWrap.removeClass('btm');
			}

		} else {
			if (nowScr == 0) {
				keywordWrap.removeClass('scroll');
			} else {
				keywordWrap.addClass('scroll');
			}
		}

		if(nowScr + nafilterChoiceTop >= nafilterChoiceOffsetT) {
			nafilterChoice.addClass('scroll_sticky');
		} else {
			nafilterChoice.removeClass('scroll_sticky');
		}

    // BTOCSITE-56703
    for(var i = 0; i < resultListSections.length; i++){

      var resultListTop = resultListSections.eq(i).offset().top; // 리스트 영역의 상단 위치
      var resultListHeight = closeAllviewBtn.eq(i).parent().parent('.list-wrap').outerHeight(); // 리스트 영역의 높이 
      var resultListBottom = resultListTop+resultListHeight;  //리스트 영역의 하단 위치

      if(scTop < resultListTop) {
        closeAllviewBtn.eq(i).addClass("outside");
      }else if(scTop > resultListBottom){
        closeAllviewBtn.eq(i).addClass("outside");
      }else{
        closeAllviewBtn.eq(i).removeClass("outside");
      }
    }
    // BTOCSITE-56703
	});

})();

/********************************************************************************************
 ************************************** ScrollStatus ***************************************
 ********************************************************************************************/
/**
 * var instance = new ScrollStatus();
 * instance.init(options);           //초기화
 *
 * @param options    ::: 설정 Object 값
 *
 * options
 *   namespace:String = ''           //scroll 이벤트 중복 방지를 위한 네임스페이스 'scroll.scrollstatus' + namespace
 *   resistance:Boolean = true       //저항(ios) 체크 유무 설정 (PC에서 true 설정 시 화면 최상단일때 더이상 스크롤에 반응안함)
 *   topThreshold:Number = 2         //ios 아래서 위로 올릴때 소프키 등장으로 처음 한계를 0 이 아닌 높이 지정
 *   frameRate:Number = 36           //timer 속도
 *   initUpdate:Boolean = false      //처음 window.load 시 체크 할지 유무
 *   exChange:Function = fun(data)   //변경시 발생될 함수
 *
 * method
 *   .update()                       //스크롤 이벤트를 타지않는 상태에서 수동 체크 함수
 *
 */
//prettier-ignore
var ScrollStatus=function(e){return function(n){var t,o,s,c,a,r,l,i,u,d,m={namespace:"",resistance:!0,topThreshold:2,frameRate:36,initUpdate:!1,exChange:void 0},p=function(){d.initUpdate&&(a=0,t.update()),e(window).on("resize.scrollstatus"+d.namespace,function(e){i=window.innerHeight}).triggerHandler("resize.scrollstatus"+d.namespace),e(window).on("scroll.scrollstatus"+d.namespace,function(e){u&&g()}).triggerHandler("scroll.scrollstatus"+d.namespace),e("html, body").on("touchstart.scrollstatus"+d.namespace,function(e){u=!1,h(),c=setInterval(f,1e3/d.frameRate)}),e("html, body").on("touchend.scrollstatus"+d.namespace,function(e){u=!0,h()})};function h(){void 0!==c&&clearInterval(c)}function f(){g()}function g(){r=0!==document.documentElement.scrollTop?document.documentElement.scrollTop:document.body.scrollTop,l=e("html").get(0).scrollHeight-i,r<=d.topThreshold&&d.resistance?(u=!1,o="up",s=0):r>=l&&d.resistance?(u=!1,o="down",s=0):(o=(s=a-r)>0?"up":s<0?"down":void 0,a=r),void 0!==d.exChange&&d.exChange({distance:s,direct:o,scrolling:u})}return{init:function(n){d=e.extend({},m,n),t=this,p()},update:function(){g()}}}}(jQuery);

